/*!
=========================================================
* 請求
=========================================================
*/
import React from "react";

import {
  Button,
  Col,
  Label,
  Row,
  Input,
  Table,
} from "reactstrap";

import CustomTd from '../ViewParts/CustomTd';
import Request from '../../common/Request';
import InputText from '../FormParts/InputText'
import InputCheckBox from '../FormParts/InputCheckBox'
import InputDatetime from '../FormParts/InputDatetime'
import DialogBase from '../Base/DialogBase';
import Format from '../../common/Format';
import InputSelect from '../FormParts/InputSelect';
import InputFile from '../FormParts/InputFile';
//import ListBase from '../Base/ListBase';
import ListBase from '../Base/ListBaseUnlimit'; // #1168-2021.7.15
import Definition from '../../common/Definition';
import {
  cst_invoice_process_status,
  cst_due_day_rule,
  INVOICE_PROCESS_STATUS
} from '../../variables/codes_map';
import WithRole from '../FormParts/ButtonWithRole';
import Common from '../../common/Common';
import { GetMessage, getErrorCodes } from '../../variables/message';
import format_url from '../../variables/format_url';
import GoogleDrive from "../../common/GoogleDrive"
import CsvDownloader from "react-csv-downloader";
import FormatCode from "../../common/FormatCode"
import CustomReport from "../../variables/custom_report"
import { INVOICE_CSV, INVOICE_CSV_APPORTIPONMENT } from '../../variables/csv'
import { sortByNumber } from "../../common/Sort"
import { 
  cst_invoice_change_flag,
  cst_tax_in_flag
} from '../../variables/codes_map';
import InputRadio from '../FormParts/InputRadio'
import MemoPopup from "../ViewParts/MemoPopup";
import Validate from "../../common/Validate";
import InputNumber from '../FormParts/InputNumber'
import AlertAndpadModal from '../ViewParts/AlertAndpadModal';

const moment = require("moment");

class List extends ListBase {
  default_column = [
    { Header: '見積ID',accessor: 'INVOICE__estimate_natural_id',headerClassName:'text-center',className:'text-left text-top',width:110,minWidth:50},
    { Header: '請求種別',accessor: 'INVOICE__due_day_rule',headerClassName:'text-center',className:'text-left text-top',width:80,minWidth:50},
    { Header: '締日',accessor: 'INVOICE__due_day',headerClassName:'text-center',className:'text-left text-top',width:130,minWidth:50},
    { Header: '請求状況',accessor: 'INVOICE__invoice_process_status',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50},
    { Header: '処理日',accessor: '___JOIN_invoice_date_list',headerClassName:'text-center',className:'text-left text-top',width:270,minWidth:50},
    { Header: '契約期間',accessor: '___JOIN_quote_available_date',headerClassName:'text-center',className:'text-left text-top',width:185,minWidth:50},
    { Header: '請求金額',accessor: 'INVOICE__invoice_amt',headerClassName:'text-center',className:'text-left text-top',width:120,minWidth:50, sortMethod: sortByNumber },
    { Header: '税抜売上金額',accessor: 'ESTIMATE__quote_subtotal_amt',headerClassName:'text-center',className:'text-left text-top',width:120,minWidth:50, sortMethod: sortByNumber },
    { Header: '関連資料',accessor: '___JOIN_invoice_document',headerClassName:'text-center',className:'text-left text-top',width:250,minWidth:50},
    { Header: '請求先情報',accessor: '___JOIN_invoice_change_master',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50},
    { Header: '請求先設定',accessor: 'invoiceChangeAction',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50, sortable : false},
    { Header: '顧客名（送り先）',accessor: '___JOIN_client_master_invoice',headerClassName:'text-center',className:'text-left text-top',width:350,minWidth:250},
    { Header: '請求担当設定',accessor: 'setInvoiceUser',headerClassName:'text-center',className:'text-left text-top',width:300,minWidth:50, sortable : false},
    { Header: '一覧請求先支店',accessor: 'setInvoiceMainBranch',headerClassName:'text-center',className:'text-left text-top',width:300,minWidth:50, sortable : false},
    { Header: '工事番号',accessor: 'PROJECT__construction_number',headerClassName:'text-center',className:'text-left text-top',width:170,minWidth:50},
    { Header: '現場名',accessor: 'PROJECT__site_name',headerClassName:'text-center',className:'text-left text-top',width:170,minWidth:50},
    { Header: '請求関係顧客別注意点',accessor: 'CUSTOMER_BRANCH__invoice_memo',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50},
    { Header: '経理課への請求メモ（確定見積送付時に入力）',accessor: 'INVOICE__invoice_user_memo',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50},
    { Header: '確認メモ',accessor: 'INVOICE__invoice_note',headerClassName:'text-center',className:'text-left text-top',width:250,minWidth:50, sortable : false},
    // { Header: '顧客への連絡事項',accessor: 'INVOICE__contact_memo',headerClassName:'text-center',className:'text-left text-top',width:250,minWidth:50, sortable : false},
    // { Header: '',accessor: 'TEMP__contact_memo',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50, sortable : false, headerLabel: "顧客への連絡ボタン"},
    { Header: '契約書',accessor: 'action_contract_create',headerClassName:'text-center',className:'text-center',width:130,minWidth:50, sortable : false},
    { Header: '請求書',accessor: 'action_invoice_upload',headerClassName:'text-center',className:'text-center',width:130,minWidth:50, sortable : false},
    // #1511 
    { Header: '確定見積：税込・税別区分',accessor: 'ESTIMATE__survey_tax_in_flag',headerClassName:'text-center',className:'text-center',width:200,minWidth:50, sortable : false},
    { Header: '確定見積：課税金額',accessor: 'ESTIMATE__quote_subtotal_amt_estimate_detail_amt_ex',headerClassName:'text-center',className:'text-center',width:200,minWidth:50, sortable : false},
    { Header: '確定見積：税額',accessor: 'ESTIMATE__quote_tax_amt',headerClassName:'text-center',className:'text-center',width:200,minWidth:50, sortable : false},
    { Header: '確定見積：非課税金額',accessor: 'ESTIMATE__estimate_detail_amt_ex',headerClassName:'text-center',className:'text-center',width:200,minWidth:50, sortable : false},
  ];
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '請求処理',
      add_url: '',
      //search_url: '/api/invoice', #1168-2021.7.15
      search_url: '/api/invoice/unlimit',
      header_md:"3",
      actions_1: "",
      all_checked: true,
      with_all_check: true,      
      checked_estimate:"",
      column: this.default_column,
      detail_search:false,
      searchData:{
        values:{
          invoice_process_status : [String(INVOICE_PROCESS_STATUS.REQUESTED)] // 検索条件の初期表示：請求状況ステータスの初期設定
        },
        errors:{},
        requiredData:{}
      },
      show_detail_search_field:false,
      data:[],
      checked_items:[],
      executionData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      dialogData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      dialogMainBranchData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      
      normalBillCount:0,
      normalBillDoneCount:0,
      specialBillCount:0,
      specialBillDoneCount:0,
      error_modal:"",
      error_message:"",
      checkedData:[],
      runData:[],
      ignoreData:[],
      listData:[],
      listGroup:[],
      checkbox_field_in_table:true,
      customerList:[],
      customerBranchList:[],
      auto_scroll:true,
      unique_key:"INVOICE__estimate_natural_id",
      paymentAllDone: false,
    });

    this.search_params = this.search_params.bind(this)
    this.dialogCsvConfirm = React.createRef();
    this.dialogConfirm = React.createRef();
    this.dialogBilledConfirm = React.createRef();
    this.dialogCancelInvoice = React.createRef();
    this.dialogInvoice = React.createRef();
    this.dialogInvoiceCsvDownload = React.createRef();
    this.dialogInvoiceCsvDownloadApportionment = React.createRef();
    this.dialogInvoiceCustomer = React.createRef();
    this.memoPopup = React.createRef();
    this.DialogInvoiceCustomerMainBranch = React.createRef();
    this.validateCallback = this.validateCallback.bind(this)
    this.search = this.search.bind(this)
    this.validateExecCallback = this.validateExecCallback.bind(this)
    this.onClickExecButton = this.onClickExecButton.bind(this)
    this.updateInvoiceNote = this.updateInvoiceNote.bind(this)
    this.search_count = this.search_count.bind(this)
    this.updateInvoiceStatus = this.updateInvoiceStatus.bind(this);
    this.search(false);
    this.updateInvoiceLockFlag = this.updateInvoiceLockFlag.bind(this)
    this.dialogContract = React.createRef();
    this.validateCheckCustomerUser = this.validateCheckCustomerUser.bind(this);
    this.alertAndpadModal = React.createRef();    
  }

  componentDidMount(){
//    this.search(false);
    Request.get("/api/customer",{without_limit:true}, res => {
      const customerList = res.Data.map(element=>{
        return {
          value:element.ulid,
          label:element.customer_name
        }
      })
      this.setState({customerList});
    })
    Request.get("/api/landmark/user_branch",{}, res => {
      const user_branch_list = res.Data.map((prop,key)=>{
        return {
            value:prop.user_branch_natural_id,
            label:prop.user_branch_name,
        }
      })
      this.setState({landmark_user_branch:user_branch_list});
    })
    document.body.style.overflow = "auto";
  }

  dataMap(data, resetCheck = false) {
    // console.log(data);
    return data.map((prop, key) => {
      const ButtonWithRole = WithRole(Button, this.props.buttons, prop)
      // 請求担当の登録確認
      let userAccountCheck = this.validateCheckCustomerUser(prop) ? false : true;
      // console.log(userAccountCheck)
      // 口座の登録確認
      let accountCheck =  (!prop.invoice_bank_name 
        || !prop.invoice_bank_branch_name 
        || !prop.invoice_bank_account_kana 
        || !prop.invoice_bank_account_type 
        || !prop.invoice_bank_account_number
      ) ? false : true;

      // 請求先住所の確認
      let addressCheck = (!prop.customer_branch_invoice_zip_code
        || !prop.customer_branch_invoice_prefecture
        || !prop.customer_branch_invoice_city
        || !prop.customer_branch_invoice_address
      ) ? false : true;
      // console.log(prop.invoice_natural_id,prop.customer_branch_id,prop.invoice_list_customer_branch_id,userAccountCheck,accountCheck,addressCheck);
      // 一覧請求フラグ設定の確認
      if (prop.invoice_list_create_flag == 1 
        && prop.invoice_list_create_type == 1){
          // 請求担当の登録確認（メイン支店）
          // if(prop.invoice_customer_user_setting == 1){
          // サブ支店の場合
          if(parseInt(prop.invoice_list_customer_branch_id) != parseInt(prop.customer_branch_id)){
            // console.log("支店担当");
            // userAccountCheck = !userAccountCheck && !prop.customer_list_invoice_customer_user_id ? false: true;
  
            // 請求先住所の確認（メイン支店）
            addressCheck =  !prop.customer_list_invoice_zip_code 
            || !prop.customer_list_invoice_prefecture 
            || !prop.customer_list_invoice_city 
            || !prop.customer_list_invoice_address ? false: true;
          }
          // 口座の登録確認（メイン支店）
          accountCheck =  !prop.customer_list_invoice_bank_name 
          || !prop.customer_list_invoice_bank_branch_name 
          || !prop.customer_list_invoice_bank_account_kana 
          || !prop.customer_list_invoice_bank_account_type 
          || !prop.customer_list_invoice_bank_account_number ? false: true;

      }
      // 現場担当者の場合
      // if(prop.invoice_customer_user_setting == 2){
      //   userAccountCheck = true;
      // }
      // console.log(prop,userAccountCheck,accountCheck,addressCheck);

      const quote_subtotal_amt = prop.non_taxable_flag === 1 // 0:課税、1:非課税
      ? prop.quote_total_amt 
      : (prop.survey_tax_in_flag === 0 ) // 0:税別、1:税込
        ? (prop.quote_total_amt - prop.quote_tax_amt) 
        : (Math.floor(prop.quote_total_amt * 10 / 11));

      // 一覧請求設定：顧客及びメイン支店フラグの確認
      const invoiceMainBranchCheck = (
        prop.invoice_list_create_flag == 1 &&
        prop.invoice_list_create_type == 1 &&
        (prop.invoice_list_customer_branch_id == null || String(prop.invoice_list_customer_branch_id).length == 0 || prop.customer_list_invoice_list_create_flag != 1 || prop.customer_list_invoice_list_create_type != 1) 
      )? true: false;


      let mainBranchCheck = {
        userAccountCheck: true,
        addressCheck: true,
        accountCheck: true,
        totalCheck: true
      }

      //　一覧請求設定→顧客　メイン支店以外のチェック
      if ( prop.invoice_list_create_flag == 1 && 
           prop.invoice_list_create_type == 1 && 
           parseInt(prop.invoice_list_customer_branch_id) != parseInt(prop.customer_branch_id) ) 
      {
        let {
          customer_list_invoice_city,
          customer_list_invoice_prefecture,
          customer_list_invoice_address,
          customer_list_invoice_zip_code,
          customer_list_invoice_bank_name,
          customer_list_invoice_bank_branch_name,
          customer_list_invoice_bank_account_kana,
          customer_list_invoice_bank_account_type,
          customer_list_invoice_bank_account_number,
        } = prop
        const noCustomerUser = this.validateCheckCustomerUser(prop);

        mainBranchCheck = {
          userAccountCheck : noCustomerUser ? false : true,
          addressCheck : (
            (!customer_list_invoice_city || toString(customer_list_invoice_city).length == 0)||
            (!customer_list_invoice_prefecture || toString(customer_list_invoice_prefecture).length == 0)||
            (!customer_list_invoice_address || toString(customer_list_invoice_address).length == 0)||
            (!customer_list_invoice_zip_code || toString(customer_list_invoice_zip_code).length == 0)
            )? false : true,
          accountCheck : (
            ( !customer_list_invoice_bank_name || toString(customer_list_invoice_bank_name).length == 0 )||
            ( !customer_list_invoice_bank_branch_name || toString(customer_list_invoice_bank_branch_name).length == 0 )||
            ( !customer_list_invoice_bank_account_kana || toString(customer_list_invoice_bank_account_kana).length == 0 )||
            ( !customer_list_invoice_bank_account_type || toString(customer_list_invoice_bank_account_type).length == 0 )||
            ( !customer_list_invoice_bank_account_number || toString(customer_list_invoice_bank_account_number).length == 0)
            )? false : true
        }
      }
      const invoice_process_status_jp = FormatCode.decode("cst_invoice_process_status",prop.invoice_process_status);
      const invoice_lock_button_active_pattern = [INVOICE_PROCESS_STATUS.NOT_YET, INVOICE_PROCESS_STATUS.REQUESTED]
      const basic_contract_signing_date = prop.basic_contract_signing_date ? moment(prop.basic_contract_signing_date) : undefined
      const now = new Date();
      const buf = moment(now);

      let __quote_subtotal_amt = this.isNullOrUndefined(prop.quote_subtotal_amt) ? 0 : parseInt(prop.quote_subtotal_amt)
      let __estimate_detail_amt_ex = this.isNullOrUndefined(prop.estimate_detail_amt_ex) ? 0 : parseInt(prop.estimate_detail_amt_ex)


      return {
        id: key,
        prop,
        INVOICE__estimate_natural_id: (<a href={GoogleDrive.getOpenUrl(prop.latest_pdf_quote_url)} target="_blank">{prop.estimate_natural_id}</a>),
        INVOICE__due_day_rule: Common.getValueFormDictArray(cst_due_day_rule, prop.due_day_rule),
        INVOICE__due_day:prop.due_day ? prop.due_day+"日" : "",
        INVOICE__invoice_process_status: (
          <>
          {invoice_process_status_jp}<br />
          <ButtonWithRole 
          button_id="BTN_G2_01_03598" 
          size="sm" 
          className="text-center" 
          disabled={ !(prop.invoice_process_status === INVOICE_PROCESS_STATUS.NOT_YET && prop.invoice_lock_flag === 0) }
          onClick={()=>{
            this.updateInvoiceStatus(prop)
          }} 
          >
            仕入チェック
        </ButtonWithRole><br />
        <ButtonWithRole 
          button_id="BTN_G2_01_03597" 
          size="sm" 
          className="text-center" 
          disabled={ !(prop.invoice_process_status === INVOICE_PROCESS_STATUS.WAITING_PROCESS) }
          onClick={()=>{
            this.updateInvoiceStatusWithPaymentRequest(prop)
          }}
          >
            請求依頼済に戻す
        </ButtonWithRole>
        <ButtonWithRole 
          button_id="BTN_G2_01_03597" 
          size="sm" 
          className="text-center" 

          disabled={prop.invoice_process_status < 4 && prop.invoice_lock_flag == 0 ? false : true}
          onClick={()=>{
            this.onClickCancelInvoiceButton(key)
          }} 
          >
            請求キャンセル
        </ButtonWithRole>
        </>
        ),
        ___JOIN_invoice_date_list: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_invoice_date_list', prop)}} />,
        ___JOIN_quote_available_date:<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_quote_available_date', prop)}} />,
        INVOICE__invoice_amt:Format.comma_delimited(prop.invoice_amt, "円"),
        ESTIMATE__quote_subtotal_amt:Format.comma_delimited((this.isNullOrUndefined(prop.survey_tax_in_flag) || prop.survey_tax_in_flag == 0 ? quote_subtotal_amt : prop.quote_total_amt - prop.quote_tax_amt), "円"),
        ___JOIN_invoice_document: (<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_invoice_document', prop)}} />),
        ___JOIN_client_master_invoice: (<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master_invoice', prop)}} />),
        PROJECT__construction_number: prop.construction_number,
        PROJECT__site_name: prop.site_name,
        CUSTOMER_BRANCH__invoice_memo:prop.invoice_memo,
        INVOICE__invoice_user_memo:prop.invoice_user_memo,
        // INVOICE__invoice_note:prop.invoice_note,
        checked: resetCheck ? undefined : ( this.checkedForItem(prop) )? true: undefined,
        INVOICE__invoice_note: (
          <InputText
            key={prop.estimate_natural_id}
            label='確認メモ'
            name='INVOICE__invoice_note'
            labelOn={false}
            multiline={true}
            validateCallback={(newData) => this.validateCallbackForMemo(newData, prop, key, 'INVOICE__invoice_note', 'invoice_note')}
            validateType={'regist'}
            rootData={{
              values : {
                invoice_note : prop.invoice_note
              },
              errors : {},
              requiredData : {}
            }}
          />
        ),
        INVOICE__contact_memo: (
          <Input
            type={"textarea"}
            value={prop.contact_memo}
            disabled={true}>
          </Input>
        ),
        TEMP__contact_memo: (
            <Button
            size="sm" 
            disabled={prop.customer_system_use_flag !== 1}
            onClick={() => {
              this.setState({
                memoPopupData : {
                  values : prop
                }
              }, () => { this.memoPopup.current.show() })
              
            }}
              className="text-center">
              顧客への連絡事項
            </Button>
        ),
        setInvoiceUser: (
          <>
            <ButtonWithRole 
              button_id="BTN_G2_01_03595" 
              size="sm" 
              onClick={()=>this.setState({
                dialogData:{
                  values:prop,
                  errors:{},
                  requiredData:{}
                }
              }, ()=>{
                this.dialogConfirm.current.show()
              })} 
              className="text-center">
              請求担当設定
            </ButtonWithRole>
            {userAccountCheck ? '' : <div style={{color:"red"}}>{GetMessage(2452)}</div> }
            {addressCheck ? '' : <div style={{color:"red"}}>{GetMessage(2453)}</div> }
            {accountCheck ? '' : <div style={{color:"red"}}>{GetMessage(2454)}</div> }
          </>
        ),
        setInvoiceMainBranch: (<>
            {/* 一覧請求顧客別→　メイン支店が登録されていない場合のエラー */}
            {prop.invoice_list_create_flag == 1?(<>
            <div>一覧設定：有</div>
            {prop.invoice_list_create_type == 1?(<>
            <div>作成区分：顧客</div>
            {invoiceMainBranchCheck == false && prop.customer_list_customer_branch_name &&(<div>請求先支店：{prop.customer_list_customer_branch_name}</div>)}
            </>):(<div>作成区分：支店</div>)}
            </>):(<div>一覧設定：無</div>)}
            
            {invoiceMainBranchCheck ? (<>
              <ButtonWithRole
                button_id="BTN_G2_01_03599" 
                size="sm" 
                onClick={()=>{
                  this.setState({
                    dialogMainBranchData:{
                      values:prop,
                      errors:{},
                      requiredData:{}
                    }
                  }); 
                  this.DialogInvoiceCustomerMainBranch.current.show();
                }} 
                className="text-center">
                請求先支店設定
              </ButtonWithRole>
              <div style={{color:"red"}}>一覧請求先の支店を設定してください。</div>
            </>):(<>
            {!mainBranchCheck.userAccountCheck&&(<div style={{color:"red"}}>{GetMessage(2452)}</div>)}
            {!mainBranchCheck.addressCheck&&(<div style={{color:"red"}}>{GetMessage(2453)}</div>)}
            {!mainBranchCheck.accountCheck&&(<div style={{color:"red"}}>{GetMessage(2454)}</div>)}
          </>)}
        </>),
        action_contract_create: (
          <>
            {/* {prop.contract_receive_flag == "1" && ( 
              <a style={{"cursor":"pointer"}} onClick={()=>this.viewConstract(prop.estimate_id)}>顧客契約書（捺印済み）</a>
              )} */}
            <ButtonWithRole 
              size="sm" 
              disabled={prop.contract_receive_flag == "1" || prop.contract_create_flag != "1" || basic_contract_signing_date != undefined && basic_contract_signing_date <= buf}
              onClick={()=>this.setState({
                dialogData:{
                  values:prop,
                  errors:{},
                  requiredData:{}
                }
              }, ()=>{
                this.dialogContract.current.show()
              })} 
              className="text-center">
              契約書作成
            </ButtonWithRole>
          </>
        ),
        action_invoice_upload : (
          <>
            <ButtonWithRole 
              size="sm" 
              disabled={prop.customer_system_use_flag === 0 || 
                        (prop.customer_system_use_flag === 1 && prop.invoice_process_status == 0) || 
                        (prop.customer_system_use_flag === 1 && prop.invoice_process_status == 1) || 
                        (prop.customer_system_use_flag === 1 && prop.invoice_process_status == 5)}
              onClick={()=>this.setState({
                dialogInvoiceData:{
                  values:prop,
                  errors:{},
                  requiredData:{}
                }
              }, ()=>{
                this.dialogInvoice.current.show()
              })} 
              className="text-center">
              請求書
            </ButtonWithRole>
          </>
        ),
        ___JOIN_invoice_change_master: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_invoice_change_master', prop)}} />,
        invoiceChangeAction:
        <>
          <ButtonWithRole 
            button_id="BTN_G2_01_03596" 
            size="sm" 
            className="text-center" 
            onClick={()=>{
              this.setState({
                dialogData:{
                  values:prop,
                  errors:{},
                  requiredData:{}
                }
              }); 
              this.dialogInvoiceCustomer.current.show()
            }} 
            >
              請求先設定
          </ButtonWithRole>
          <Button
            color="secondary"
            size="sm"
            onClick={()=>this.updateInvoiceLockFlag(data, prop, key)}
            disabled={ !(prop.invoice_process_status in invoice_lock_button_active_pattern) }
          >
            請求ロック {prop.invoice_lock_flag ? "ON" : "OFF" }
          </Button>
        </>,
        ESTIMATE__survey_tax_in_flag: this.isNullOrUndefined(prop.survey_tax_in_flag) || prop.survey_tax_in_flag == 0 ? '税別' : '税込',
        ESTIMATE__quote_subtotal_amt_estimate_detail_amt_ex: Format.comma_delimited((__quote_subtotal_amt - __estimate_detail_amt_ex)),
        ESTIMATE__quote_tax_amt: Format.comma_delimited(this.isNullOrUndefined(prop.quote_tax_amt)? 0 : parseInt(prop.quote_tax_amt)),
        ESTIMATE__estimate_detail_amt_ex: Format.comma_delimited(this.isNullOrUndefined(prop.estimate_detail_amt_ex)? 0 : parseInt(prop.estimate_detail_amt_ex))
      }
    /*
        this.isNullOrUndefined(data.survey_tax_in_flag) ? '税別' : (data.survey_tax_in_flag == 0 ? '税別' : '税込み'), // 確定見積：税込・税抜区分
        確定見積：税込・税抜区分 ESTIMATE__survey_tax_in_flag
        確定見積：課税金額 ESTIMATE__quote_subtotal_amt_estimate_detail_amt_ex
        確定見積：税額（税抜きの場合） data.quote_tax_amt
        確定見積：非課税金額 estimate_detail_amt_ex
    */
      });
  }
  isNullOrUndefined(data){
    if(data === undefined || data === null){
      return true;
    }
    return false;
  }
  viewConstract(estimate_id){
    // ファイル情報取得
    Request.get('/api/cufile', { ref_id : estimate_id, file_type : 5 }, res => {
      if(res.Code == 200){
        res.Data.map((file, index) => {
          window.open(`/api/gcs_download/${file.file_path}?d=${file.file_name}`);
        })		
      }
    })
  }
  validateCallbackForMemo(newData, invoice, key, name, type){
    this.setState({
      data : [
        ...this.state.data.slice(0, key),
        {
          ...this.state.data[key],
          [name] : {
            ...this.state.data[key][name],
            props : {
              ...this.state.data[key][name].props,
              rootData : newData
            }
          }
        },
        ...this.state.data.slice(key+1),
      ]
    })
    if(Object.keys(newData.errors).length > 0){
      return;
    }
    const originMemo = this.state.data[key][name].props.rootData.values[type];
    if ( originMemo == newData.values[type]
      || (originMemo == null && newData.values[type] == "")) {
      return;
    }

    const url = '/api/invoice/note/'+invoice.ulid
    const params = {
      ...invoice,
      [type]:newData.values[type]
    }
    Request.put(url, params, (res)=>{
      console.log(res.Data)
      // this.search(); // メモ更新時は再検索しない
    })
  }

  updateMemo(data){
    // 無効な文字列チェック
		const max_length_validate = Validate.length(data.contact_memo, "", "text_ja_20000")
		if(!max_length_validate.valid){
      this.props.alertModal.current.showErrorModal({message:max_length_validate.message});
			return;
		}
    
    const url = '/api/invoice/note/'+data.ulid
    const params = {
      ...data,
    }
    Request.put(url, params, (res)=>{
      this.search();
    })
  }

  updateInvoiceNote(event, invoice){
    const url = '/api/invoice/note/'+invoice.ulid
    const params = {
      ...invoice,
      invoice_note:event.target.value
    }
    Request.put(url, params, (res)=>{
      console.log(res.Data)
      this.search();
    })
  }
  // #1394 仕入チェック
  updateInvoiceStatus(invoice){
    const url = '/api/invoice/payment_check/'+invoice.ulid
    const params = {
      ...invoice
    }
    Request.put(url, params, (res)=>{
      console.log(res.Data)
      if(res.Code != 200){
        this.props.alertModal.current.showErrorModal({
          message:res.Message 
        }, ()=>{
        })
      }else{
        this.props.alertModal.current.confirmCheck({
          title: "更新が完了しました。",
          messageNo: 2507,
          closeBtn: false
        }, ()=>{
          this.search(true);
        }, false)
      }
    })
  }

  // #1458
  updateInvoiceStatusWithPaymentRequest(prop){
    const message = '請求依頼済に戻します。よろしいですか？'
    this.props.alertModal.current.confirmCheck({message:message},()=>{
      const url = "/api/invoice/" + prop.ulid

      const params = {
        ...prop,
        invoice_process_status: 1
      }

      Request.put(url, params, (res) => {
        console.log(res.Data)
        if(res.Code != 200){
          this.props.alertModal.current.showErrorModal({
            message:res.Message 
          }, ()=>{
          })
        }else{
          this.props.alertModal.current.confirmCheck({
            title: "更新が完了しました。",
            messageNo: 2507,
            closeBtn: false
          }, ()=>{
            this.search(true);
          }, false)
        }
      })
    })
  }


  search_params() {
    const {values} = this.state.searchData
    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
        acc[key] = values[key]
      }
      return acc
    },{})
  }

  search(refreshTaskFlag = true) {
    /* ここは開発者が記述 */
    if (!this.validate()) {
        // do nothing
        return;
    }
    this.search_count();
    var searchParmas = this.search_params()
    searchParmas["pager_index"] = "0";
    searchParmas["pager_limit"] = this.state.paging["limit"];
    Request.get(this.state.search_url, 
      searchParmas
      , res => {

        this.setState({
          data: this.dataMap(res.Data, true),
          searched_data : res.Data,
          paging: {
            "index": parseInt(searchParmas["pager_index"]),
            "limit": parseInt(searchParmas["pager_limit"])
          },  
          executionData : {
            ...this.state.executionData,
            values : {
              ...this.state.executionData.values,
              invoice_closing_date : this.state.searchData.values.payment_finish_date_to
            }
          },
          checkedItems : [] // 検索した場合、チェック初期化
        });
      
    })
    if(refreshTaskFlag){
      this.props.refreshTaskCount()
      this.setState({
        executionData: {
          ...this.state.executionData,
          values : {
            ...this.state.executionData.values,
            invoice_closing_date : new Date()
          }
        }
      });
    }
  }

  /* #1168-2021.7.15 データ件数の取得 */
  search_count() {
    var search_param = this.search_params();
    search_param["data_count"] = 1;
    Request.get(this.state.search_url, search_param, res => {
        this.setState({data_count: res.Data});
    })
  }
  
  validate(){
    let message = getErrorCodes(this.state.executionData.errors)

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  async validateCallback(newData, callback=()=>{}){
    const customerParam = (this.state.customerList.findIndex(customer=>customer.value==newData.values.invoice_customer_ulid)>-1)
    ? {
      invoice_customer_ulid: newData.values.invoice_customer_ulid,
      invoice_customer_name: undefined
    } : {
      invoice_customer_ulid:undefined,
      invoice_customer_name: (newData.values.invoice_customer_ulid != undefined)?newData.values.invoice_customer_ulid:newData.values.invoice_customer_name
    }
//    console.log(customerParam, newData);
    const customerBranchList = this.state.searchData.values.invoice_customer_ulid!=customerParam.invoice_customer_ulid
    ? (customerParam.invoice_customer_ulid
      ? await new Promise(resolve=>{
        Request.get("/api/customer/branch",{
          customer_ulid:customerParam.invoice_customer_ulid,
          customer_branch_delete_flag : 1
        }, res => {
          resolve(res.Data.map(element=>{
            return {
              value:element.ulid,
              label:element.customer_branch_name
            }
          })) 
        })
      })
      : [])
    : this.state.customerBranchList
    const customerBranchParam = this.state.searchData.values.invoice_customer_ulid==customerParam.invoice_customer_ulid
    ? (customerBranchList.findIndex(customer=>customer.value==newData.values.invoice_customer_branch_ulid)>-1)
      ? {
        invoice_customer_branch_ulid: newData.values.invoice_customer_branch_ulid,
        invoice_customer_branch_name: undefined
      }
      : {
        invoice_customer_branch_ulid: undefined,
        invoice_customer_branch_name: (newData.values.invoice_customer_branch_ulid != undefined)? newData.values.invoice_customer_branch_ulid:newData.values.invoice_customer_branch_name
      }
    : {
      invoice_customer_branch_ulid: undefined,
      invoice_customer_branch_name: undefined
    }
    
    this.setState({
      searchData:{
        ...this.state.searchData,
        ...newData,
        values:{
          ...newData.values,
          ...customerParam,
          ...customerBranchParam
        }
      },
      customerBranchList
    }, ()=>callback())
  }

  validateExecCallback(newData, callback=()=>{}){
    this.setState({
      executionData:{
        ...this.state.executionData,
        ...newData
      }
    }, ()=>callback())
  }

  search_field_cols() {
    return (
      <>
        <Col xl="3" lg="3" md="3" sm="4">
          <InputCheckBox
            label='請求状況'
            name='INVOICE__invoice_process_status'
            labelOn={true}
            validateCallback={this.validateCallback}
            options={cst_invoice_process_status}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col xl="3" lg="3" md="3" sm="4">
          <InputCheckBox
            label='請求種別'
            name='INVOICE__due_day_rule'
            labelOn={true}
            validateCallback={this.validateCallback}
            options={cst_due_day_rule}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col xl="3" lg="3" md="3" sm="4">
          <InputText
            label='締日'
            name='INVOICE__due_day'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
            disabled={!(this.state.searchData.values.due_day_rule && this.state.searchData.values.due_day_rule.includes("4"))}
          />
        </Col>
        <Col xl="3" lg="3" md="3" sm="4">
          <InputText
            label='見積ID'
            name='INVOICE__estimate_natural_id'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col xl="3" lg="3" md="3" sm="4">
          <InputSelect
            label="顧客会社名"
            labelOn={true}
            name="INVOICE__invoice_customer_ulid"
            options={this.state.customerList}
            validateCallback={this.validateCallback} 
            validateType='search'
            rootData={this.state.searchData}
            isSearchable={true}
            isCreatable={true}
            searchStartLength={2}
          />
        </Col>

        <Col xl="3" lg="3" md="3" sm="4">
          <InputSelect
            label="顧客支店名"
            labelOn={true}
            key={`invoice_customer_branch_${this.state.searchData.values.invoice_customer_ulid}`}
            name="INVOICE__invoice_customer_branch_ulid"
            options={this.state.customerBranchList}
            validateCallback={this.validateCallback} 
            validateType='search'
            rootData={this.state.searchData}
            isSearchable={true}
            isCreatable={true}
          />
        </Col>

        <Col xl="3" lg="3" md="3" sm="4">
          <InputDatetime
            label='契約期間開始日（FROM)'
            name='INVOICE__quote_available_start_date_from'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>

        <Col xl="3" lg="3" md="3" sm="4">
          <InputDatetime
            label='契約期間開始日（TO)'
            name='INVOICE__quote_available_start_date_to'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />          
        </Col>

        <Col xl="3" lg="3" md="3" sm="4">
          <InputDatetime
            label='仕入実施日（FROM)'
            name='PAYMENT__payment_finish_date_from'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>

        <Col xl="3" lg="3" md="3" sm="4">
          <InputDatetime
            label='仕入実施日（TO)'
            name='PAYMENT__payment_finish_date_to'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />          
        </Col>
        <Col xl="3" lg="3" md="3" sm="4">
          <InputText
            label='工事番号'
            name='PROJECT__construction_number'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
        <Col xl="3" lg="3" md="3" sm="4">
          <InputSelect label="ランドマーク支店"
            name="USER_BRANCH__user_branch_natural_id"
            labelOn={true} 
            validateCallback={this.validateCallback} 
            options={this.state.landmark_user_branch}
            enterSearch={true}
            enterCallback={this.searchWithPageIndex}
            rootData={this.state.searchData} />
        </Col>
        <Col xl="3" lg="3" md="3" sm="4">
          <InputText
            label='現場名'
            name='PROJECT__site_name'
            labelOn={true}
            validateCallback={this.validateCallback}
            enterCallback={this.searchWithPageIndex}
            enterSearchFlag={true}
            rootData={this.state.searchData}
            validateType={'search'}
          />
        </Col>
      </>
    );
  }
  // 請求担当チェック
  validateCheckCustomerUser(prop){
    const {
      customer_list_invoice_customer_user_id,
      customer_branch_invoice_customer_user_id,
      invoice_customer_user_id,
      invoice_list_create_flag,
      invoice_list_create_type,
      invoice_customer_user_setting,
      customer_branch_id,
      invoice_list_customer_branch_id,
    } = prop
    // 一覧請求作成　かつ　顧客単位かつ　サブ支店
    if(invoice_list_create_flag == 1 &&
       invoice_list_create_type == 1 && 
       // invoice_customer_user_setting == 1 && 
       parseInt(customer_branch_id) != parseInt(invoice_list_customer_branch_id) ){
      return !customer_list_invoice_customer_user_id 
    }else{
      // 支店請求担当 または 現場　または　都度
      return !invoice_customer_user_id
    }
  }

  detail_search_field_btn(){
      return (<></>);
  }
  detail_search_field_cols(){
      return (<></>);
  }

  async onClickExecButton() {

    if(!this.validate()){
      return;
    }
    
//    const checked_items = this.state.data.filter((item) => item.checked)
    var checked_items = this.state.checkedItems;

    // 請求担当者が設定されてない場合は、アラートを出す。
    const noCustomerUser = checked_items.filter(item => {
        return this.validateCheckCustomerUser(item.prop)
    })
    
    //  console.log(noCustomerUser,checked_items)
    // 送付先住所が設定されてない場合は、アラートを出す。
    const noAddress = checked_items.filter(item => {
      // 一覧請求設定及び顧客設定の場合
      if ( item.prop.invoice_list_create_flag == 1
          && item.prop.invoice_list_create_type == 1
          // && item.prop.invoice_customer_user_setting == 1 
          && parseInt(item.prop.customer_branch_id) != parseInt(item.prop.invoice_list_customer_branch_id)) {
        // メイン支店の請求担当をチェック
        return (!item.prop.customer_list_invoice_zip_code
              ||!item.prop.customer_list_invoice_prefecture
              ||!item.prop.customer_list_invoice_city
              ||!item.prop.customer_list_invoice_address);
      }
      return (!item.prop.customer_branch_invoice_zip_code
            ||!item.prop.customer_branch_invoice_prefecture
            ||!item.prop.customer_branch_invoice_city
            ||!item.prop.customer_branch_invoice_address
      );
    })
    // console.log(noAddress)


    const message = [];


    let runData = [];
    let ignoreData = [];
    let listData = [];
    let listGroup = [];

    // 口座情報が設定されてないデータ取得
    const noAccountInfo = checked_items.filter(function ( item ){
      // 一覧請求設定及び顧客設定の場合、チェックをメイン請求支店の口座をチェック
      if ( item.prop.invoice_list_create_flag == 1 && 
           item.prop.invoice_list_create_type == 1 && 
           parseInt(item.prop.customer_branch_id) != parseInt(item.prop.invoice_list_customer_branch_id)) {
          //  console.log(item.prop)
           return (!item.prop.customer_list_invoice_bank_name || 
                  !item.prop.customer_list_invoice_bank_branch_name || 
                  !item.prop.customer_list_invoice_bank_account_kana || 
                  !item.prop.customer_list_invoice_bank_account_type ||
                  !item.prop.customer_list_invoice_bank_account_number     
          )

      }
      return (!item.prop.invoice_bank_name
        || !item.prop.invoice_bank_branch_name 
        || !item.prop.invoice_bank_account_kana 
        || !item.prop.invoice_bank_account_type
        || !item.prop.invoice_bank_account_number)
      }
    )

    // 一覧請求設定→メイン支店の設定がされていないデータを取得
    const noInvoiceListMainBranch = checked_items.filter((item)=> (
      (item.prop.invoice_list_create_flag == 1 && 
       item.prop.invoice_list_create_type == 1 && 
      (item.prop.invoice_list_customer_branch_id == null || String(item.prop.invoice_list_customer_branch_id).length == 0  || item.prop.customer_list_invoice_list_create_flag != 1 || item.prop.customer_list_invoice_list_create_type != 1))
    ))

    // メイン支店の情報のみ収集する
    let listMainBranch = {}
    checked_items.forEach((item)=>{
      let {
        invoice_list_create_flag,
        invoice_list_create_type,
        customer_branch_id,
        invoice_list_customer_branch_id
      }=item.prop
      if ( invoice_list_create_flag == 1 && invoice_list_create_type == 1 ) {
        listMainBranch[ invoice_list_customer_branch_id ] = (invoice_list_customer_branch_id == customer_branch_id)? {...item.prop}: null
      }
    })

    let mainBranchError = [];
    let mainBranchErrorDetail = [];
    if ( Object.keys(listMainBranch).length > 0 ) {
      let nondata_keys = Object.keys(listMainBranch).filter((main_branch_id)=>listMainBranch[main_branch_id] == null)
      // console.log(nondata_keys)
      if ( nondata_keys.length > 0 ) {

       mainBranchError = await new Promise((resolve, reject)=>{
          Request.get("/api/customer/branch/invoice",{"branch_id":nondata_keys.join(",")},(res)=>{
            let error = res.Data.filter((item)=>{
              if(item.invoice_list_create_flag == 1 && item.invoice_list_create_type == 1){
                listMainBranch[item.id] = item;
              }
              // console.log(item)

              mainBranchErrorDetail.push({bank_error: !item.invoice_bank_name 
                                  || !item.invoice_bank_branch_name 
                                  || !item.invoice_bank_account_kana 
                                  || !item.invoice_bank_account_type 
                                  || !item.invoice_bank_account_number,
                      user_error: !item.invoice_customer_user_id,
                      address_error: !item.customer_branch_invoice_zip_code
                                  || !item.customer_branch_invoice_prefecture
                                  || !item.customer_branch_invoice_city
                                  || !item.customer_branch_invoice_address
              })
              return !item.invoice_bank_name 
                      || !item.invoice_bank_branch_name 
                      || !item.invoice_bank_account_kana 
                      || !item.invoice_bank_account_type 
                      || !item.invoice_bank_account_number
                      || !item.invoice_customer_user_id
                      || !item.customer_branch_invoice_zip_code
                      || !item.customer_branch_invoice_prefecture
                      || !item.customer_branch_invoice_city
                      || !item.customer_branch_invoice_address

            })
            // console.log(error,listMainBranch)
            resolve(error)
          })
        })
      }
    }
    // console.log(listMainBranch,noAccountInfo)

    switch (this.state.executionData.values.exec_action) {
      case "請求書を生成":
        if (checked_items.length<1) {
          return
        }

        // チェックした請求書の締日を選択してない場合は、アラートを出す。
        if(!this.state.executionData.values.invoice_closing_date){
          message.push(2440)
        } 

        // 請求担当者が設定されてない場合は、アラートを出す。
        if(noCustomerUser.length > 0){
          message.push(2456)
        }

        // 送付先住所が設定されてない場合は、アラートを出す。
        if(noAddress.length > 0){
          message.push(2458)
        }

        // 口座情報が設定されてない場合は、アラートを出す。
        if(noAccountInfo.length > 0){
          message.push(2457)
        }

        // 一覧請求のメイン支店が設定されてない場合、アラートを出す。
        if (noInvoiceListMainBranch.length > 0) {
          message.push(2494)
        }
        // console.log(mainBranchError)
        // メイン支店の請求情報確認
        if(mainBranchError.length > 0){
          let bank_error = false
          let user_error = false
          let address_error = false
          mainBranchErrorDetail.map((err)=>{
            if (!bank_error && err.bank_error == true) {
              message.push(2620)
              bank_error = true
            }
            if (!user_error && err.user_error == true) {
              message.push(2622)
              user_error = true
            }
            if (!address_error && err.address_error == true) {
              message.push(2621)
              address_error = true
            }
          })
        }
        
        if(message.length > 0){
          this.props.alertModal.current.showErrorModal({messageNo:message});
          return false;
        }

        // 支店のフラグを取得する
        const customerBranchList = await Promise.all(checked_items.map(async (item)=>{
          const customerBranch = await Request.getCustomerBranch(item.prop.customer_branch_natural_id,false);
          return {
            customer_branch_natural_id : item.prop.customer_branch_natural_id,
            invoice_list_create_flag : customerBranch.invoice_list_create_flag 
           }
        }))
        const customerBranchObj = {}
        customerBranchList.forEach((item) => {
          customerBranchObj[item.customer_branch_natural_id] = {
            ...item
          }
        })
        // 請求依頼済かつ、請求ロックフラグが0:請求ロック解除だけ実行対象とする。
        runData = checked_items.filter((item) => (item.prop.invoice_process_status === INVOICE_PROCESS_STATUS.REQUESTED && item.prop.invoice_lock_flag === 0))
        // 契約書UL待ちから区画番号変更によりチェックへ移動したものは除外
        runData = runData.filter((item) => (!(item.prop.order_box_status == 4 && item.prop.before_order_box_status == 7)))
        listData = checked_items.filter((item) => (customerBranchObj[item.prop.customer_branch_natural_id].invoice_list_create_flag == 1 && item.prop.invoice_process_status != INVOICE_PROCESS_STATUS.CANCEL))
        // 一覧請求書データの作成
        // console.log(checked_items)
        listGroup = checked_items.reduce(function (result, item) {
          // 一覧設定のみ抽出
          if ( item.prop.invoice_list_create_flag == 1 ) {
            var element = result.find(function (p) {
              //　作成区分が顧客の場合
              if ( item.prop.invoice_list_create_type == 1 && p.invoice_list_create_type == 1 ) {
                return p.invoice_list_customer_branch_id === item.prop.invoice_list_customer_branch_id
              }
              //　作成区分が支店の場合
              else {
                return p.customer_branch_natural_id === item.prop.customer_branch_natural_id
              }
            });
            if (element) {
              if (item.prop.invoice_process_status != INVOICE_PROCESS_STATUS.CANCEL){
                element.count ++; // count
                element.data.push(item.prop)
              }
            } else {
              if (item.prop.invoice_process_status != INVOICE_PROCESS_STATUS.CANCEL){
                // 作成区分が顧客の場合、メイン支店を第一オブジェクトに設定する
                if (item.prop.invoice_list_create_type == 1) {

                  if(listMainBranch[item.prop.invoice_list_customer_branch_id]["invoice_natural_id"] == undefined){
                    listMainBranch[item.prop.invoice_list_customer_branch_id]["invoice_natural_id"] = null;
                  }
                  if(listMainBranch[item.prop.invoice_list_customer_branch_id]["invoice_closing_date"] == undefined){
                    listMainBranch[item.prop.invoice_list_customer_branch_id]["invoice_closing_date"] = null;
                  }
                  if(listMainBranch[item.prop.invoice_list_customer_branch_id]["invoice_amt"] == undefined){
                    listMainBranch[item.prop.invoice_list_customer_branch_id]["invoice_amt"] = null;
                  }
                  if(listMainBranch[item.prop.invoice_list_customer_branch_id]["payment_deadline"] == undefined){
                    listMainBranch[item.prop.invoice_list_customer_branch_id]["payment_deadline"] = null;
                  }
                  console.log(listMainBranch[item.prop.invoice_list_customer_branch_id])
                  result.push({
                    ...listMainBranch[item.prop.invoice_list_customer_branch_id],
                    count: 1,
                    data : [{...item.prop}]
                  });
                }
                else {
                  result.push({
                    ...item.prop,
                    count: 1,
                    data : [{...item.prop}]
                  });
                }
              }
            }
            return result;
          }
          return (result)? result: [];
        }, []);
        this.setState({
          checked_estimate:'請求書を生成',
          checkedData: checked_items,
          runData : runData,
          listData : listData,
          listGroup : listGroup,
          noInvoiceUser: [],
          noInvoiceAddress: [],
        },()=>{
          this.dialogBilledConfirm.current.show()
        })
        break;
      case "請求済に":
        if (checked_items.length<1) {
          return
        }

        // 請求書生成済、請求処理待ちを実行対象とする。
        // 20241012 請求書生成urlを参照するように修正
        runData = checked_items.filter((item) => (item.prop.invoice_process_status === INVOICE_PROCESS_STATUS.GENERATED || item.prop.invoice_process_status === INVOICE_PROCESS_STATUS.WAITING_PROCESS))
        // console.log(runData)
        // 特別承認で作られた請求書で契約書チェック待ちではないものを除外
        runData = runData.filter((item) => (item.prop.special_agreement_flag != 1 || (item.prop.special_agreement_flag == 1 && item.prop.order_box_status >= 7)));

        // 20251007 #2479対応
        // console.log(runData,noCustomerUser)
        runData = runData.filter(
          ( item )=> !noCustomerUser.some(no=>no.prop.id == item.prop.id) 
        )

        // 請求担当者が設定されてない場合は、アラートを出す。
        if(noCustomerUser.length > 0){
          message.push(2456)
        }        

        // メイン支店の請求情報確認
        if(mainBranchError.length > 0){
          let user_error = false
          mainBranchErrorDetail.map((err)=>{
            if (!user_error && err.user_error == true) {
              message.push(2622)
              user_error = true
            }
          })
        }

        if(message.length > 0){
          this.props.alertModal.current.showErrorModal({messageNo:message});
          return false;
        }        

        // console.log(runData)
        this.setState({
          checked_estimate:'請求済に',
          checkedData: checked_items,
          runData : runData,
          listData : [],
          noInvoiceUser: noCustomerUser,
          noInvoiceAddress: [],
        },()=>{
          this.dialogBilledConfirm.current.show()
        })
        break
      case "請求処理待ちに":
        if (checked_items.length<1) {
          return
        }

        //請求依頼済、請求書生成済かつ、請求ロックが0:請求ロック解除を実行対象とする。
        runData = checked_items.filter((item) => ((item.prop.invoice_process_status === INVOICE_PROCESS_STATUS.REQUESTED || item.prop.invoice_process_status === INVOICE_PROCESS_STATUS.GENERATED) && item.prop.invoice_lock_flag === 0))
        this.setState({
          checked_estimate:'請求処理待ちに',
          checkedData: checked_items,
          runData : runData,
          listData : [],
          noInvoiceUser: [],
          noInvoiceAddress: [],
        },()=>{
          this.dialogBilledConfirm.current.show()
        })
        break
      case "今日請求済のCSVを出力":
        const todayFormat = moment().format('YYYY-MM-DD')
        const invoiceData = await new Promise((resolve, reject)=>{
          Request.get(this.state.search_url, 
            {
              invoice_process_finish_date_today:true 
            }
            , res => {
              resolve(res.Data)
          })
        }) 
        const todayInvoiceCsvData = invoiceData&& invoiceData.length>0 && invoiceData.filter(datum=>{
          return todayFormat == moment(datum.invoice_process_finish_date).format('YYYY-MM-DD')
        })
        if (!todayInvoiceCsvData || todayInvoiceCsvData.length<1){
          this.props.alertModal.current.showErrorModal({messageNo:2438})
          return
        }
        this.setState({
          checked_estimate:'今日請求済のCSVを出力',
          csvData: todayInvoiceCsvData.map(element=>{
            element.due_day = element.due_day_rule==3?element.due_day:""
            element.due_day_rule=FormatCode.decode("cst_due_day_rule", element.due_day_rule)
            element.invoice_process_status=FormatCode.decode("cst_invoice_process_status", element.invoice_process_status)
            element.quote_available_start_date = moment(element.quote_available_start_date).format('YYYY/MM/DD')
            element.quote_available_end_date = moment(element.quote_available_end_date).format('YYYY/MM/DD')
            element.invoice_process_finish_date = moment(element.invoice_process_finish_date).format('YYYY/MM/DD')
            return element
          }),
        },()=>{
          this.dialogCsvConfirm.current.show()
        })
        break
      case "請求をキャンセル":
        if (checked_items.length<1) {
          return
        }

        // 請求担当者が設定されてない場合は、アラートを出す。
        if(noCustomerUser.length > 0){
          message.push(2456)
        }

        if(message.length > 0){
          this.props.alertModal.current.showErrorModal({messageNo:message});
          return false;
        }

        // 請求キャンセル、売掛金の入金済み、一部入金の場合でかつ、請求ロックが0:請求ロック解除ではない場合は対象外とする
        runData = checked_items.filter((item) => item.prop.invoice_process_status !== INVOICE_PROCESS_STATUS.CANCEL && (item.prop.receivable_collect_total_amt === null || item.prop.receivable_collect_total_amt === 0) && item.prop.invoice_lock_flag === 0)
        ignoreData = checked_items.filter((item) => item.prop.receivable_collect_total_amt !== null && item.prop.receivable_collect_total_amt !== 0)
        this.setState({
          checked_estimate:'請求をキャンセル',
          checkedData: checked_items,
          runData : runData,
          ignoreData : ignoreData
        },()=>{
          this.dialogBilledConfirm.current.show()
        })
        break
      case "請求先変更済み書類（送付状・請求書・契約書）を生成":
        if (checked_items.length<1) {
          return
        }

        // チェックした請求書の締日を選択してない場合は、アラートを出す。
        if(!this.state.executionData.values.invoice_closing_date){
          message.push(2440)
        } 

        // 請求担当者が設定されてない場合は、アラートを出す。
        if(noCustomerUser.length > 0){
          message.push(2456)
        }

        // 口座情報が設定されてない場合は、アラートを出す。
        if(noAccountInfo.length > 0){
          message.push(2457)
        }

        if(message.length > 0){
          this.props.alertModal.current.showErrorModal({messageNo:message});
          return false;
        }


        // 請求依頼済以降のステータスは請求書生成可能（何度でも）、未処理、請求キャンセル、請求書送付先住所が変更されてない見積は無視する
        runData = checked_items.filter((item) => 
          item.prop.invoice_process_status !== INVOICE_PROCESS_STATUS.NOT_YET  // 未処理
          && item.prop.invoice_process_status !== INVOICE_PROCESS_STATUS.CANCEL  // 請求キャンセル
          && item.prop.change_invoice_flag !== 0 // 請求書送付先住所が変更されてない
          && item.prop.invoice_lock_flag === 0  // 請求ロックが0:請求ロック解除
        )

        this.setState({
          checked_estimate:'請求先変更済み書類（送付状・請求書・契約書）を生成',
          checkedData: checked_items,
          runData : runData,
        },()=>{
          this.dialogBilledConfirm.current.show()
        })
      default:
        return
    }
    this.allStateClear();
  }
  // 請求キャンセルボタン押下時の処理
  async onClickCancelInvoiceButton(index) {
    if(!this.validate()){
      return;
    }

    const checked_item = this.state.data.filter((_, idx) => idx == index);
    if (checked_item.length == 0) {
      return
    }
    const message = [];
    let runData = [];
    let ignoreData = [];
    const payment_statuses = checked_item[0].prop.payment_statuses || "";
    const paymentStatusArray=payment_statuses.split(",").map(Number);
    const paymentAllDone = !paymentStatusArray.every(status=> status == 4);

    // 請求担当者が設定されてない場合は、アラートを出す。
    const noCustomerUser = checked_item.filter(function (item) {
      // 一覧請求設定及び顧客設定の場合、チェックをスルーする
      if ( item.prop.invoice_list_create_flag == 1 && item.prop.invoice_list_create_type == 1 && parseInt(item.prop.customer_branch_id) != parseInt(item.prop.invoice_list_customer_branch_id)) {
        return false;
      }
      return (!item.prop.invoice_customer_user_id);
    })
    // 請求担当者が設定されてない場合は、アラートを出す。
    if(noCustomerUser.length > 0){
      message.push(2456)
    }

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }

    // 請求キャンセル、売掛金の入金済み、一部入金の場合でかつ、請求ロックが0:請求ロック解除ではない場合は対象外とする
    runData = checked_item.filter((item) => item.prop.invoice_process_status !== INVOICE_PROCESS_STATUS.CANCEL && (item.prop.receivable_collect_total_amt === null || item.prop.receivable_collect_total_amt === 0) && item.prop.invoice_lock_flag === 0)
    ignoreData = checked_item.filter((item) => item.prop.receivable_collect_total_amt !== null && item.prop.receivable_collect_total_amt !== 0)

    // 請求キャンセルボタン追加前のダイアログを使用している
    this.setState({
      checked_estimate:'請求をキャンセル',
      checkedData: checked_item,
      runData : runData,
      ignoreData : ignoreData,
      paymentAllDone: paymentAllDone,
    },()=>{
      // console.log("Updated state.paymentAllDone:", this.state.paymentAllDone);
      this.dialogCancelInvoice.current.show()
    })

    this.allStateClear();
  }

  getButtonIdByExecutionType(executionType) {
    switch(executionType){
      case "請求書を生成":
      return "BTN_G2_01_03600"
      case "請求処理待ちに":
      return "BTN_G2_01_03601"
      case "請求済に":
      return "BTN_G2_01_03610"
      case "今日請求済のCSVを出力":
      return "BTN_G2_01_03611"
      default:
      return undefined
    }
  }

  checkbox_field_cols(){
    const buttonIdByExecutionType = this.getButtonIdByExecutionType(this.state.executionData.values.exec_action)
    const ButtonWithRole = WithRole(Button, this.props.buttons)
    return (
      <>
        <Col md='3'>
          <Label for="" className="search-text-order">チェックした確定見積について</Label>
          <InputSelect
            label='処理'
            name='TEMP__exec_action'
            options={[
              {value:'請求書を生成', label:'請求書を生成する'},
              {value:'請求処理待ちに', label:'請求処理待ちにする'},
              {value:'請求済に', label:'請求済にする'},
              // {value:'請求をキャンセル', label:'請求をキャンセルする'},
              {value:'請求先変更済み書類（送付状・請求書・契約書）を生成', label:'請求先変更済み書類（送付状・請求書・契約書）を生成する'},
              // {value:'今日請求済のCSVを出力', label:'今日請求済のCSVを出力する'},
            ]}
            rootData={this.state.executionData}
            validateCallback={this.validateExecCallback} 
          />
        </Col>
        <Col md='3'>
          <ButtonWithRole 
            button_id={buttonIdByExecutionType}
            onClick={this.onClickExecButton}
            className="float-right"
          >
           実行
          </ButtonWithRole>
        </Col>
        <Col md='3'>
          <InputDatetime
            label='チェックした請求書の締日'
            name='INVOICE__invoice_closing_date'
            labelOn={true}
            validateCallback={this.validateExecCallback}
            rootData={this.state.executionData}
            validateType="regist"
          />
        </Col>
        <Col md='3'>
          <ButtonWithRole 
            onClick={() => {
              this.setState({
                dialogTitle : "一覧CSV出力"
              }, () => {
                this.dialogInvoiceCsvDownload.current.show()
              })
            }}
          >
            一覧CSV出力
          </ButtonWithRole>
          <ButtonWithRole 
            onClick={() => {
              this.setState({
                dialogTitle : "一覧CSV出力(売上按分）"
              }, () => {
                this.dialogInvoiceCsvDownloadApportionment.current.show()
              })
            }}
          >
            一覧CSV出力(売上案分）
          </ButtonWithRole>

      </Col>
      </>
    );
  }
  
  dialog_defines() {
    return (
      <>
        <DialogConfirm
          ref={this.dialogConfirm}
          data={this.state.dialogData}
          positive={true}
          positive_label="はい"
          negative_label="いいえ"
          refreshCallback={this.search}
          {...this.props}
        />
        <DialogBilledConfirm 
          ref={this.dialogBilledConfirm}
          title={this.state.checked_estimate}
          checkedData={this.state.checkedData}
          runData={this.state.runData}
          ignoreData={this.state.ignoreData}
          listData={this.state.listData}
          listGroup={this.state.listGroup}
          noInvoiceUser={this.state.noInvoiceUser}
          noInvoiceAddress={this.state.noInvoiceAddress}
          invoice_closing_date={this.state.executionData.values.invoice_closing_date}
          positive_label="はい"
          negative_label="いいえ"
          positive={true}
          refreshCallback={this.search}
          {...this.props}
        />
        <DialogCsvDownload
          ref={this.dialogCsvConfirm}
          data={this.state.csvData}
          positive_label="はい"
          negative_label="いいえ"
          default_footer={true} 
          refreshCallback={this.search}
        />
        <DialogInvoice ref={this.dialogInvoice} 
          data={this.state.dialogInvoiceData}
          positive={true}
          positive_label="保存"
          negative_label="キャンセル"
          refreshCallback={this.search}
          {...this.props}
        />
        <DialogInvoiceCsvDownload
          ref={this.dialogInvoiceCsvDownload} 
          {...this.props}
          search_params = {() => this.search_params()}
          positive={true}
          default_footer={true}
        />
        <DialogInvoiceCsvDownloadApportionment
          ref={this.dialogInvoiceCsvDownloadApportionment} 
          {...this.props}
          search_params = {() => this.search_params()}
          positive={true}
          default_footer={true}
        />        
        <DialogInvoiceCustomer 
          ref={this.dialogInvoiceCustomer} 
          data={this.state.dialogData}
          positive={true}
          refreshCallback={()=>{this.search(true)}}
          {...this.props}
        />
         <MemoPopup 
          ref={this.memoPopup} 
          data={this.state.memoPopupData} 
          positive={true}
          updateMemo = {(data) => this.updateMemo(data)}
          {...this.props}
        />
        <DialogInvoiceCustomerMainBranch
          ref={this.DialogInvoiceCustomerMainBranch} 
          data={this.state.dialogMainBranchData}
          positive={true}
          refreshCallback={this.search}
          {...this.props}
        />
        <DialogContract ref={this.dialogContract} 
          data={this.state.dialogData}
          positive={true}
          refreshCallback={this.search}
          {...this.props}
        />
        <DialogCancelInvoice
          ref={this.dialogCancelInvoice}
          title={this.state.checked_estimate}
          checkedData={this.state.checkedData}
          runData={this.state.runData}
          ignoreData={this.state.ignoreData}
          listData={this.state.listData}
          listGroup={this.state.listGroup}
          invoice_closing_date={this.state.executionData.values.invoice_closing_date}
          positive_label="はい"
          negative_label="いいえ"
          positive={true}
          refreshCallback={(andpad_use_flag,estimate_natural_id)=> {
              if(andpad_use_flag){
                  this.alertAndpadModal.current.toggleErrorModal(
                    {
                      estimate: [estimate_natural_id],
                    }
                  );
              } else {
                this.search()
              }
            }
          }
          paymentAllDone={this.state.paymentAllDone}
          {...this.props}
        />
        <AlertAndpadModal
          ref={this.alertAndpadModal} 
          returnCallback={() => {
            this.search()        
          }}
        />  
      </>
    );
  }

  // 請求ロック OFF/ON
  updateInvoiceLockFlag(data, prop, key){
    const message = prop.invoice_lock_flag ? '請求ロックを解除します。よろしいですか?' : '請求ロックをします。よろしいですか?'
    this.props.alertModal.current.confirmCheck({message:message},()=>{
      const url = "/api/invoice/" + prop.ulid

      // 値を反転させる（0:請求ロック解除、1:請求ロック中）
      const params = {
        invoice_lock_flag: prop.invoice_lock_flag === 0 ? 1 : 0
      }

      Request.patch(url, params, (res) => {
        // resはtrue,falseで返却されるため数値に戻す
        data[key].invoice_lock_flag = res.Data.invoice_lock_flag ? 1 : 0
        this.setState({
          data: this.dataMap(data, true)
        })
        this.search()
      })
    })
  }
}

class DialogCsvDownload extends DialogBase {
  constructor(props) {
    super(props);
    moment.locale('ja');
    const now = new Date();
    const buf = moment(now);
    const filedate = buf.format("YYYYMMDDHHmm");
    Object.assign(this.state, {
      title: '今日請求済のCSVを出力します。よろしいですか？',
      filename: "今日請求済CSV_"+filedate,
      headers: [
        {
          id: 'estimate_natural_id',
          displayName: '見積ID'
        },
        {
          id: 'customer_name',
          displayName:'請求先顧客名'
        },
        {
          id: 'customer_branch_name',
          displayName:'請求先顧客支店名'
        },
        {
          id: 'customer_user_name',
          displayName:'請求先担当者名'
        },
        {
          id: 'invoice_amt',
          displayName:'請求金額'
        },
        {
          id: 'quote_available_start_date',
          displayName:'契約期間：開始日'
        },
        {
          id: 'quote_available_end_date',
          displayName:'契約期間：終了日'
        },
        {
          id: 'due_day_rule',
          displayName:'請求種別'
        },
        {
          id: 'due_day',
          displayName:'締日'
        },
        {
          id: 'invoice_process_status',
          displayName:'請求ステータス'
        },
        {
          id: 'invoice_process_finish_date',
          displayName:'請求完了日'
        }
      ]
    });
  }

  bodyContent() {
    return <>
      <div className="modal-footer">
        <Button color="secondary" onClick={this.handleClickNegative}>キャンセル</Button>
          <CsvDownloader
            filename={this.state.filename}
            columns={this.state.headers}
            datas={this.props.data}
            separator=","
            bom={true}
          >
            <Button color="info" onClick={() => { this.handleClickNegative() }}>ダウンロード</Button>
          </CsvDownloader>
      </div>
    </>
  }
}

class DialogConfirm extends DialogBase {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '請求担当者を設定しますか？',
      data: this.props.data,
      userList:[]
    });
    this.validateCallback = this.validateCallback.bind(this)
    this.validate = this.validate.bind(this)
  }

  componentDidUpdate(prevProps){
    if (prevProps.data !== this.props.data){
      const params = {
        customer_branch_natural_id:this.props.data.values.customer_branch_natural_id,
        show_delete_data : 0
        // ...this.props.data,
        // invoice_history_flag:1
      }
      Request.get('/api/customer/user', params, (res)=>{
        const user_list = res.data.map((user)=>{
          const {
            customer_user_division_name,
            customer_user_name,
            customer_user_tel,
            customer_user_email,
            id,
            customer_branch_ulid,
            customer_branch_invoice_prefecture,
            customer_branch_invoice_city,
            customer_branch_invoice_address,
          } = user

          
          return {
            value : id,
            label: `${customer_user_division_name || ""} ${customer_user_name} (${customer_user_tel || ""})`
          }
          
        })
        // console.log(user_list)
        this.setState({
          data: {
            values: {
              ...this.props.data.values,
            },
            errors:{
              ...(this.props.data.values.invoice_customer_user_id?{}:{invoice_customer_user_id:[GetMessage(2024)]})
            },
            requiredData:{
              invoice_customer_user_id:[GetMessage(2024)],
            }
          },
          userList:user_list
        })
      })
      
    }
  }

  validateCallback(newData, callback=()=>{}){
    const {
      customer_branch_invoice_prefecture,
      customer_branch_invoice_city,
      customer_branch_invoice_address,
    } = newData.values
    this.setState({
      data:{
        ...newData,
        values:{
          ...newData.values,
        }
      }
    }, ()=>callback())
  }

  validate(){
    let message = getErrorCodes(this.state.data.errors)

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  handleClickPositive(){
    if(this.validate()) {
      const {
        ulid,
        update_timestamp,
        invoice_process_status,
        invoice_customer_user_id
      } = this.state.data.values;
  
      const updateParams = {
        invoice_ulid : ulid,
        updatetimestamp : update_timestamp,
        invoice_customer_user : invoice_customer_user_id
      }
      // console.log(invoice_process_status);
      Request.post(`/api/invoice/status`, { checked_data : [updateParams], invoice_process_status }, 
        (res)=>{
          this.props.refreshCallback()
          this.toggleModal();
      })
    }
  }

  bodyContent() {
    // console.log('modal state', this.state)
    return (
      <>
        <InputSelect
          isSearchable={true}
          label='担当者'
          name='CUSTOMER_USER__invoice_customer_user_id'
          options={this.state.userList}
          rootData={this.state.data}
          validateCallback={this.validateCallback} 
        />
      </>
    );
  }
}
class DialogBilledConfirm extends DialogBase {
  constructor(props) {
    super(props);
    Object.assign(this.state, {
      title: this.props.title+'します。よろしいですか？',
    });
  }


  makeEstimateDetail(estimate_data, estimate_detail_data, object_array_detail_count, customer_branch_name, request_type){
    let object_array_detail = {};
    let add_other_data = {
      ESTIMATE_DETAIL__other_tax_detail_name: "", //その他課税項目名
      ESTIMATE_DETAIL__other_tax_detail_amt: "", //その他課税金額
      ESTIMATE_DETAIL__other_nontax_detail_name:"" , //その他非課税項目名
      ESTIMATE_DETAIL__other_nontax_detail_amt:"" , //その他課税金額
      ESTIMATE__other_tax_total_amt:"" , //その他課税小計（税別）
      ESTIMATE__other_nontax_total_amt:"" , //その他非課税小計  
    };
    let array_count = 0;
    let row_count = 1;
    for(let i=1;i<=object_array_detail_count+2;i++){
      const estimateDetail = estimate_detail_data[i-1]
      if (estimateDetail){
        if(estimateDetail.estimate_detail_add_flag == "0"){
          if(row_count <= object_array_detail_count){
            object_array_detail[`row_start_${row_count}`] = {
              ESTIMATE_DETAIL__estimate_detail_name : estimateDetail.estimate_detail_name,
              ESTIMATE__quote_capacity_qty : estimate_data.quote_capacity_qty,
              ESTIMATE_DETAIL__estimate_detail_unit_cost : estimateDetail.estimate_detail_unit_cost,
              ESTIMATE_DETAIL__estimate_detail_term : estimateDetail.estimate_detail_term,
              ESTIMATE_DETAIL__estimate_detail_term_type : estimateDetail.estimate_detail_term_type,
              ESTIMATE_DETAIL__estimate_detail_amt : estimateDetail.estimate_detail_amt,
              ESTIMATE__survey_capacity_qty_type : FormatCode.decode("cst_survey_capacity_qty_type", estimate_data.survey_capacity_qty_type),
              ESTIMATE__survey_parking_name : estimate_data.survey_parking_name,
    
              // 独自帳票項目
              CUSTOMER_BRANCH__customer_branch_name : customer_branch_name,
              ESTIMATE__survey_parking_address_contract : estimate_data.survey_parking_address_contract,
              REQUEST__request_type : FormatCode.decode("cst_request_type", request_type),
              ESTIMATE__survey_parking_rent : estimate_data.survey_parking_rent,
              ESTIMATE__survey_key_money : estimate_data.survey_key_money,
              ESTIMATE__survey_commission : estimate_data.survey_commission,
              ESTIMATE__quote_subtotal_amt : estimate_data.quote_subtotal_amt,
              ESTIMATE__quote_tax_amt : estimate_data.quote_tax_amt,
              ESTIMATE__quote_total_amt : estimate_data.quote_total_amt,
    
            }
            array_count++  
          }
          row_count++
        }else{
          // 追加項目 非課税
          if(estimateDetail.non_taxable_flag == "1"){
            add_other_data["ESTIMATE_DETAIL__other_nontax_detail_name"] = estimateDetail.estimate_detail_name != null ? estimateDetail.estimate_detail_name : "";
            add_other_data["ESTIMATE_DETAIL__other_nontax_detail_amt"] = estimateDetail.estimate_detail_amt != null ? estimateDetail.estimate_detail_amt : "";
          // 追加項目 課税
          }else if(estimateDetail.non_taxable_flag == "0"){
            add_other_data["ESTIMATE_DETAIL__other_tax_detail_name"] = estimateDetail.estimate_detail_name != null ? estimateDetail.estimate_detail_name : "";
            add_other_data["ESTIMATE_DETAIL__other_tax_detail_amt"] = estimateDetail.estimate_detail_amt != null ? estimateDetail.estimate_detail_amt : "";
          }
        }
      } else {
        if(row_count <= object_array_detail_count){

          object_array_detail[`row_start_${row_count}`] = {
            ESTIMATE_DETAIL__estimate_detail_name : "",
            ESTIMATE__quote_capacity_qty : "",
            ESTIMATE_DETAIL__estimate_detail_unit_cost : "",
            ESTIMATE_DETAIL__estimate_detail_term : "",
            ESTIMATE_DETAIL__estimate_detail_term_type : "",
            ESTIMATE_DETAIL__estimate_detail_amt : "",
            ESTIMATE__survey_capacity_qty_type : "",
            ESTIMATE__survey_parking_name : "",

            // 独自帳票項目
            CUSTOMER_BRANCH__customer_branch_name : "",
            ESTIMATE__survey_parking_address_contract : "",
            REQUEST__request_type : "",
            ESTIMATE__survey_parking_rent : "",
            ESTIMATE__survey_key_money : "",
            ESTIMATE__survey_commission : "",
            ESTIMATE__quote_subtotal_amt : "",
            ESTIMATE__quote_tax_amt : "",
            ESTIMATE__quote_total_amt : "",
          }
        }
        row_count++

      }
      const {ESTIMATE_DETAIL__other_nontax_detail_amt:estimate_detail_amt_ex,
             ESTIMATE_DETAIL__other_tax_detail_amt:estimate_detail_amt,
            } = add_other_data

      add_other_data["ESTIMATE__other_nontax_total_amt"] = estimate_detail_amt_ex != "" ? estimate_detail_amt_ex : "";
      // add_other_data["ESTIMATE__other_tax_total_amt"] =  estimate_data.request_type == "3" && estimate_data.survey_tax_in_flag == 0 ?  estimate_data.quote_subtotal_amt + (estimate_detail_amt?estimate_detail_amt:0) : estimate_data.quote_subtotal_amt - (estimate_detail_amt_ex != "" ? estimate_detail_amt_ex : 0);
      add_other_data["ESTIMATE__other_tax_total_amt"] =  estimate_data.quote_subtotal_amt - (estimate_detail_amt_ex != "" ? estimate_detail_amt_ex : 0);

    }
    return {object_array_detail, array_count,add_other_data};
  }

  calcPaymentDeadline = (payment_due_rule_month, payment_due_rule_day, estimate_payment_deadline) => {
    const { invoice_closing_date } = this.props;

    // 請求書PDF生成日
    const invoice_process_pdf_date = moment().format("YYYY-MM-DDT00:00:00")
    // 支払期限日計算
    let payment_deadline = ""
    // console.log(estimate_payment_deadline)

    if(estimate_payment_deadline !== "" && estimate_payment_deadline !== null){
      payment_deadline = moment(estimate_payment_deadline);
      payment_deadline = payment_deadline.format("YYYY-MM-DDT00:00:00")

    }else{
      payment_deadline = moment(invoice_closing_date);
      // 支払期限日ルール：月
      payment_deadline.add(payment_due_rule_month, 'months');
      // 支払期限日ルール：日が「月末」の場合、当月の最終日を設定する
      if(payment_due_rule_day == 0){
        const endOfMonth = payment_deadline.endOf('month').format('DD');
        payment_deadline.date(endOfMonth);
      } else {
        payment_deadline.date(payment_due_rule_day);
      }

      payment_deadline = payment_deadline.format("YYYY-MM-DDT00:00:00")

    }
    // console.log(payment_deadline)
    

    return {
      invoice_closing_date,
      invoice_process_pdf_date,
      payment_deadline
    }
  }

  async handleClickPositive(){
    if (this.props.title==="請求書を生成"){
      // const customer_branch_natural_id_list_for_custom_detail = ["CUB0000001B"]
      let progressPercent = 10;
      let invoiceReportList = {};
      
      Promise.all(this.props.runData.map(async (datum)=>{
        const {
          estimate_natural_id,
          request_natural_id,
          customer_natural_id,
          customer_user_natural_id,
          customer_branch_natural_id,
          subcontract_customer_branch_natural_id,
          subcontract_customer_user_natural_id,
          project_natural_id,
          invoice_natural_id,
          invoice_amt,
          // invoice_process_pdf_date,
          purchase_order_send_flag,
          quote_available_start_date,
          quote_available_end_date,
          ulid,
          update_timestamp,
          request_type,
          tax_in_flag,
          payment_due_rule_month,
          payment_due_rule_day,
          // invoice_closing_date,

          customer_branch_name,
          invoice_customer_user_name,
          invoice_process_pdf_date : origin_invoice_process_pdf_date,
          customer_list_invoice_bank_account_kana,
          customer_list_invoice_bank_account_number,
          customer_list_invoice_bank_account_type,
          customer_list_invoice_bank_branch_name,
          customer_list_invoice_bank_name,
          invoice_list_create_flag,
          invoice_list_create_type,
          invoice_customer_user_setting,
          user_branch_natural_id,
          estimate_payment_deadline,
          customer_list_invoice_customer_user_name,
          customer_list_customer_branch_name,
          customer_branch_id,
          invoice_list_customer_branch_id,
        } = datum.prop

        // console.log( datum.prop);
        
        let invoice_customer_user = invoice_customer_user_name;

        // const { invoice_closing_date } = this.props;

        const { 
          invoice_closing_date, 
          invoice_process_pdf_date, 
          payment_deadline 
        } = this.calcPaymentDeadline(payment_due_rule_month, payment_due_rule_day,estimate_payment_deadline );

        Request.setProgress(Math.floor(progressPercent))
        const invoiceCustomerBranch = await Request.getCustomerBranch(customer_branch_natural_id,false);
        // console.log(invoiceCustomerBranch);
        //請求共通パラメータ取得
        const invoiceCommon = await Request.getInvoiceCommon({
          customer_branch_natural_id,
          customer_user_natural_id,
          subcontract_customer_branch_natural_id,
          subcontract_customer_user_natural_id,
          request_natural_id,
          project_natural_id,
          invoice_natural_id,
          invoice_process_pdf_date,
          estimate_natural_id,
          quote_available_start_date,
          quote_available_end_date,
          request_type,
          payment_deadline,
          invoice_closing_date,
          invoice_amt,
          user_branch_natural_id,
        })
        // 一覧請求作成 かつ 顧客単位の場合
        if(invoice_list_create_flag == 1 && invoice_list_create_type == 1){
          // 支店担当者の場合
          // if(invoice_customer_user_setting == 1){
          // サブ支店の場合
          if(parseInt(invoice_list_customer_branch_id) != parseInt(customer_branch_id)){
            invoice_customer_user = customer_list_invoice_customer_user_name;
          }
          const {CUSTOMER_BRANCH__invoice_bank_account_kana,
                CUSTOMER_BRANCH__invoice_bank_account_number,
                CUSTOMER_BRANCH__invoice_bank_account_type,
                CUSTOMER_BRANCH__invoice_bank_branch_name,
                CUSTOMER_BRANCH__invoice_bank_name
                } = invoiceCommon.object_invoice

          invoiceCommon.object_customer.CUSTOMER_BRANCH__customer_branch_name = customer_list_customer_branch_name
          invoiceCommon.object_invoice.CUSTOMER_BRANCH__invoice_bank_account_kana = (CUSTOMER_BRANCH__invoice_bank_account_kana == null)? customer_list_invoice_bank_account_kana : CUSTOMER_BRANCH__invoice_bank_account_kana;
          invoiceCommon.object_invoice.CUSTOMER_BRANCH__invoice_bank_account_number = (CUSTOMER_BRANCH__invoice_bank_account_number == null)? customer_list_invoice_bank_account_number : CUSTOMER_BRANCH__invoice_bank_account_number;
          invoiceCommon.object_invoice.CUSTOMER_BRANCH__invoice_bank_account_type = (CUSTOMER_BRANCH__invoice_bank_account_type == "")? customer_list_invoice_bank_account_type : CUSTOMER_BRANCH__invoice_bank_account_type;
          invoiceCommon.object_invoice.CUSTOMER_BRANCH__invoice_bank_branch_name = (CUSTOMER_BRANCH__invoice_bank_branch_name == null)? customer_list_invoice_bank_branch_name : CUSTOMER_BRANCH__invoice_bank_branch_name;
          invoiceCommon.object_invoice.CUSTOMER_BRANCH__invoice_bank_name = (CUSTOMER_BRANCH__invoice_bank_name == "未設定")? customer_list_invoice_bank_name : CUSTOMER_BRANCH__invoice_bank_name;
          // console.log(invoiceCommon);
        }


        const {
          CUSTOMER_BRANCH__customer_branch_invoice_zip_code:customer_branch_invoice_zip_code,
          CUSTOMER_BRANCH__customer_branch_invoice_list_zip_code:customer_branch_invoice_list_zip_code,
          JOIN_invoice_addr:invoice_addr,
          JOIN_invoice_list_addr:invoice_list_addr,
          invoice_create_flag,
          contract_create_flag,
        } = invoiceCustomerBranch;

        // G03_PDF_請求書送付状
        const G03_PDF = await new Promise((resolve, reject)=>{

          Request.post('/api/pout/G03_PDF', {
            ...invoiceCommon,
            object_each_data:{
              CUSTOMER_BRANCH__customer_branch_invoice_zip_code:customer_branch_invoice_zip_code,
              JOIN_invoice_addr:invoice_addr,
              CUSTOMER_USER__customer_user_name : invoice_customer_user
            },
            format_url:GoogleDrive.getFormatUrl(format_url.G03_PDF),
          }, res=>{
            progressPercent = progressPercent + 90/(this.props.runData.length*3) 
            Request.setProgress(Math.floor(progressPercent))
            resolve(res)
          }, err => {
            resolve({
              estimate_natural_id : estimate_natural_id,
              Code : 805,
            })
          })
        })
        if(G03_PDF.Code >= 800){
          return G03_PDF;
        }


        // G04_PDF_請求書
        let G04_PDF = {};

        // B表内訳
        let inhouse1_pdf_url = {};
        let inhouse1_pdf = CustomReport.inhouse1_pdf.find(item => {
          return item.customer_natural_id === customer_natural_id 
        })
        // console.log(inhouse1_pdf);


        //請求書送付有無が有りのもの
        if(invoice_create_flag == "1"){

          // G04_PDF_請求書個別パラメータ取得
          const estimate_data = await new Promise((resolve, reject)=>{
            Request.get('/api/order', {
              estimate_natural_id,
              extension_flag:1
            }, res=>{
              if (!res.Data[0]){
                resolve({
                  estimate_natural_id : estimate_natural_id,
                  Code : 805,
                })
              }
              resolve(res.Data[0])
            }, err => {
              resolve({
                estimate_natural_id : estimate_natural_id,
                Code : 805,
              })
            })
          })

          if(estimate_data.Code >= 800){
            return {
              estimate_natural_id : estimate_natural_id,
              Code : 805,
            }
          }
          const object_each_data = {
            ESTIMATE__survey_commission_discount_amt : estimate_data.survey_commission_discount_amt,
            ESTIMATE__quote_subtotal_amt : estimate_data.quote_subtotal_amt,
            ESTIMATE__quote_tax_amt : estimate_data.quote_tax_amt,
            ESTIMATE__quote_total_amt : estimate_data.quote_total_amt,
            ESTIMATE__survey_parking_address_contract : estimate_data.survey_parking_address_contract,
            ESTIMATE__quote_plotting_number : estimate_data.quote_plotting_number,
            INVOICE__invoice_amt : invoice_amt,

            CUSTOMER_BRANCH__tax_in_flag : tax_in_flag,
            ESTIMATE__quote_available_start_date : estimate_data.quote_available_start_date,
            ESTIMATE__quote_available_end_date : estimate_data.quote_available_end_date,
            ESTIMATE__survey_capacity_qty_type : estimate_data.survey_capacity_qty_type,
            ESTIMATE__survey_discount_amt : estimate_data.survey_discount_amt,
            ESTIMATE__survey_key_money : estimate_data.survey_key_money,
            ESTIMATE__survey_adjustment_amt : estimate_data.survey_adjustment_amt,

            ESTIMATE__survey_commission_discount_rate : estimate_data.survey_commission_discount_rate,
            ESTIMATE__survey_commission : estimate_data.survey_commission,
            PROJECT__register_type : estimate_data.register_type,
            
          }
          // 独自請求書
          let customInvoice = CustomReport.invoice.find(item => {
            return item.customer_natural_id === customer_natural_id 
            && item.customer_branch_natural_id === customer_branch_natural_id
          })

          customInvoice = customInvoice || CustomReport.invoice.find(item => {
            return item.customer_natural_id === customer_natural_id 
          })

          const estimate_detail_data = customInvoice
          ? await new Promise((resolve, reject)=>{
            // 独自帳票 detail
            Request.get(`/api/estimate/detail/original/${estimate_natural_id}`, {}, res=>{
              if (!res.Data[0]){
                resolve({
                  estimate_natural_id : estimate_natural_id,
                  Code : 805,
                })
              }
              resolve(res.Data)
            }, err => {
              resolve({
                estimate_natural_id : estimate_natural_id,
                Code : 805,
              })
            })
          })
          : await new Promise((resolve, reject)=>{
            // 確定見積詳細取得API呼び出し
            Request.get(`/api/estimate/detail/quote/${estimate_natural_id}`, {}, res=>{
              if (!res.Data[0]){
                resolve({
                  estimate_natural_id : estimate_natural_id,
                  Code : 805,
                })
              }
              resolve(res.Data)
            }, err => {
              resolve({
                estimate_natural_id : estimate_natural_id,
                Code : 805,
              })
            })
          })

          if(estimate_detail_data.Code >= 800){
            return {
              estimate_natural_id : estimate_natural_id,
              Code : 805,
            }
          }
        
          let object_array_detail_count = (customInvoice && customInvoice.array_count) ? customInvoice.array_count : 11
          const {object_array_detail, array_count,add_other_data} = this.makeEstimateDetail(estimate_data, estimate_detail_data, object_array_detail_count, customer_branch_name, request_type);

          invoiceCommon.object_estimate.ESTIMATE__quote_subtotal_amt = estimate_data.quote_subtotal_amt;

          G04_PDF = await new Promise((resolve, reject)=>{
            Request.post( `/api/pout/${customInvoice ? customInvoice.format : "G04_PDF"}`, {
              ...invoiceCommon,
              format_url:GoogleDrive.getFormatUrl((invoiceCommon.CUSTOMER_BRANCH__invoice_format_url
                ?invoiceCommon.CUSTOMER_BRANCH__invoice_format_url
                :customInvoice ? format_url[customInvoice.format] : format_url.G04_PDF)),
              object_each_data : {
                ...object_each_data,
                ...add_other_data,
                object_array_detail
              },
              object_common:{
                ...invoiceCommon.object_common,
                array_count:array_count
              }
            }, res=>{
              progressPercent = progressPercent + 90/(this.props.runData.length*3) 
              Request.setProgress(Math.floor(progressPercent))
              resolve(res)
            }, err => {
              resolve({
                estimate_natural_id : estimate_natural_id,
                Code : 805,
              })
            })
          })
          if(G04_PDF.Code >= 800){
            return G04_PDF;
          }

          // 住友不動産の場合は、B表内訳も生成する
          if(inhouse1_pdf && customer_natural_id === inhouse1_pdf.customer_natural_id){
            const estimate_detail_data_for_y11_pdf = await new Promise((resolve, reject)=>{
              // 確定見積詳細取得API呼び出し
              Request.get(`/api/estimate/detail/quote/${estimate_natural_id}`, {}, res=>{
                if (!res.Data[0]){
                  resolve({
                    estimate_natural_id : estimate_natural_id,
                    Code : 805,
                  })
                }
                resolve(res.Data)
              }, err => {
                resolve({
                  estimate_natural_id : estimate_natural_id,
                  Code : 805,
                })
              })
            })

            if(estimate_detail_data_for_y11_pdf.Code >= 800){
              return {
                estimate_natural_id : estimate_natural_id,
                Code : 805,
              }
            }

            let object_array_detail_count = inhouse1_pdf.array_count;
            const {object_array_detail, array_count,add_other_data} = this.makeEstimateDetail(estimate_data, estimate_detail_data_for_y11_pdf, object_array_detail_count, customer_branch_name, request_type);

            inhouse1_pdf_url = await new Promise((resolve, reject)=>{
              Request.post( "/api/pout/Y11_PDF", {
                ...invoiceCommon,
                format_url:GoogleDrive.getFormatUrl(format_url.Y11_PDF),
                object_each_data : {
                  ...object_each_data,
                  ...add_other_data,
                  object_array_detail
                },
                object_common:{
                  ...invoiceCommon.object_common,
                  array_count:array_count
                }
              }, res=>{
                // progressPercent = progressPercent + 90/(this.props.runData.length*3) 
                // Request.setProgress(progressPercent)
                resolve(res)
              }, err => {
                resolve({
                  estimate_natural_id : estimate_natural_id,
                  Code : 805,
                })
              })
            })

            if(inhouse1_pdf_url.Code >= 800){
              return {
                estimate_natural_id : estimate_natural_id,
                Code : 805,
              }
            }

          }
        }

        let updateResult = {}
        const updateParams = {
          send_letter_pdf_url : G03_PDF.Data ? G03_PDF.Data.spreadsheet_id : null,
          invoice_pdf_url : G04_PDF.Data ? G04_PDF.Data.spreadsheet_id : null,
          inhouse1_pdf_url : inhouse1_pdf_url.Data ? inhouse1_pdf_url.Data.spreadsheet_id : null,
          invoice_ulid:ulid,
          updatetimestamp:update_timestamp,
          // invoice_process_pdf_date : invoice_process_pdf_date,
          invoice_process_pdf_date : origin_invoice_process_pdf_date !== null ? origin_invoice_process_pdf_date : invoice_process_pdf_date, // 請求書生成日
          invoice_closing_date : this.props.invoice_closing_date,
          payment_deadline : payment_deadline,
        }
        updateResult = await new Promise((resolve, reject)=>{
          Request.post(`/api/invoice/status`, { checked_data : [updateParams], invoice_process_status : INVOICE_PROCESS_STATUS.GENERATED}, 
          (res)=>{
            resolve(res)
          },
          (err)=>{
            resolve({
              estimate_natural_id : estimate_natural_id,
              Code : 805,
            })
          })
        })
        return {
          G03_PDF,
          G04_PDF,
          updateResult
        }
      }))
      .then((result)=>{
        // console.log("result ", result);

        // pdf生成失敗した見積IDを取得する
        const pdfErrorList = result.filter(item => item.Code >= 800).map((item => (item.estimate_natural_id)))
        // console.log("listGroup ", this.props.listGroup);
        // console.log("runData ", this.props.runData);

        //一覧請求を実行
        if (this.props.listGroup.length > 0) {

          Promise.all(this.props.listGroup.map(async (datum)=>{
            if (this.props.runData.length > 0){
              Request.setProgress(90,"一覧請求作成中");
            }else{
              progressPercent = 90 / this.props.listGroup.length;
              Request.setProgress(Math.floor(progressPercent),"一覧請求作成中");
            }
  
              console.log(datum)
              const {
                customer_natural_id,
                customer_branch_natural_id,
                customer_user_natural_id,
                subcontract_customer_branch_natural_id,
                subcontract_customer_user_natural_id,
                request_natural_id,
                project_natural_id,
                invoice_natural_id,
                // invoice_process_pdf_date,
                estimate_natural_id:mst_estimate_natural_id,
                quote_available_start_date,
                quote_available_end_date,
                request_type,
                // payment_deadline,
                // invoice_closing_date,
                invoice_amt,
                data,
                update_timestamp,
                payment_due_rule_month,
                payment_due_rule_day,
                user_branch_natural_id,
                estimate_payment_deadline,
                invoice_customer_user_id: origin_invoice_customer_user_id,
              } = datum

              const invoice_customer_user_id = origin_invoice_customer_user_id != null ? origin_invoice_customer_user_id : null
              const estimate_natural_id = mst_estimate_natural_id ? mst_estimate_natural_id : data[0].estimate_natural_id

              const { 
                invoice_closing_date, 
                invoice_process_pdf_date, 
                payment_deadline 
              } = this.calcPaymentDeadline(payment_due_rule_month, payment_due_rule_day, estimate_payment_deadline);
              
              // 独自一覧請求対応（飯田産業）
              let customInvoiceList = CustomReport.invoice_list.find(item => {
                return item.customer_natural_id === customer_natural_id 
                && item.customer_branch_natural_id === customer_branch_natural_id
                && item.only_customer_branch_auto_flag !== true
              })
    
              customInvoiceList = customInvoiceList || CustomReport.invoice_list.find(item => {
                return item.customer_natural_id === customer_natural_id 
                && item.only_customer_branch_auto_flag !== true
              })


              //請求共通パラメータ取得
              const invoiceCommon = await Request.getInvoiceCommon({
                customer_branch_natural_id,
                customer_user_natural_id,
                subcontract_customer_branch_natural_id,
                subcontract_customer_user_natural_id,
                request_natural_id,
                project_natural_id,
                invoice_natural_id,
                invoice_process_pdf_date,
                estimate_natural_id,
                quote_available_start_date,
                quote_available_end_date,
                request_type,
                payment_deadline,
                invoice_closing_date,
                invoice_amt,
                user_branch_natural_id
              })
              let object_array_detail = {}
              let object_array_detail_count = customInvoiceList?customInvoiceList.array_count:100
              const up_data = [];
              
              // 見積データ取得
              const estimate_data = await new Promise((resolve, reject)=>{
                Request.get('/api/order', {
                  estimate_natural_id,
                  extension_flag:1
                }, res=>{
                  if (!res.Data[0]){
                    resolve({
                      estimate_natural_id : estimate_natural_id,
                      Code : 805,
                    })
                  }
                  resolve(res.Data[0])
                }, err => {
                  resolve({
                    estimate_natural_id : estimate_natural_id,
                    Code : 805,
                  })
                })
              })

              if(estimate_data.Code >= 800){
                return {
                  estimate_natural_id : estimate_natural_id,
                  Code : 805,
                }
              }

              for(let i=1;i<=object_array_detail_count;i++){
                const row_data = data[i-1]

                //課税非課税追加項目対応 
                let add_other_data = {ESTIMATE_DETAIL__other_nontax_detail_name:"",
                                      ESTIMATE_DETAIL__other_nontax_detail_amt:"",
                                      ESTIMATE__other_nontax_total_amt:"",
                                      ESTIMATE__other_tax_total_amt:"",
                                      ESTIMATE_DETAIL__other_tax_detail_name:"",
                                      ESTIMATE_DETAIL__other_tax_detail_amt:""};                
                
                if (row_data){

                  const estimate_detail_data = await new Promise((resolve, reject)=>{
                    // 確定見積詳細取得API呼び出し
                    // console.log(row_data)
                    Request.get(`/api/estimate/detail/quote/${row_data.estimate_natural_id}`, {}, res=>{
                      if (!res.Data[0]){
                        resolve({
                          estimate_natural_id : row_data.estimate_natural_id,
                          Code : 805,
                        })
                      }
                      resolve(res.Data)
                    }, err => {
                      resolve({
                        estimate_natural_id : row_data.estimate_natural_id,
                        Code : 805,
                      })
                    })
                  })
                  
          
                  if(estimate_detail_data.Code >= 800){
                    return {
                      estimate_natural_id : row_data.estimate_natural_id,
                      Code : 805,
                    }
                  }
          
                  // その他用に、小計を設定
                  let _quote_subtotal_amt = row_data.quote_subtotal_amt;

                  // 賃料計　飯田産業用
                  let _survey_parking_rent_total = 0;


                  estimate_detail_data.forEach((estimateDetail)=>{
                    if(estimateDetail.estimate_detail_add_flag == 1){
                      // 追加項目 非課税
                      if(estimateDetail.non_taxable_flag == "1"){
                        add_other_data["ESTIMATE_DETAIL__other_nontax_detail_name"] = estimateDetail.estimate_detail_name != null ? estimateDetail.estimate_detail_name : "";
                        add_other_data["ESTIMATE_DETAIL__other_nontax_detail_amt"] = estimateDetail.estimate_detail_amt != null ? estimateDetail.estimate_detail_amt : "";
                        add_other_data["ESTIMATE__other_nontax_total_amt"] = estimateDetail.estimate_detail_amt != null ? estimateDetail.estimate_detail_amt : "";
                        add_other_data["ESTIMATE__other_tax_total_amt"] = _quote_subtotal_amt - (estimateDetail.estimate_detail_amt != null ? estimateDetail.estimate_detail_amt : 0);
                      // 追加項目 課税
                      }else if(estimateDetail.non_taxable_flag == "0"){
                        add_other_data["ESTIMATE_DETAIL__other_tax_detail_name"] = estimateDetail.estimate_detail_name != null ? estimateDetail.estimate_detail_name : "";
                        add_other_data["ESTIMATE_DETAIL__other_tax_detail_amt"] = estimateDetail.estimate_detail_amt != null ? estimateDetail.estimate_detail_amt : "";
              
                      }
                    }else{
                      _survey_parking_rent_total = _survey_parking_rent_total + estimateDetail.estimate_detail_amt;
                    }
                  })  
                  
                 // 小計
                  //  ・税別の場合、税額を加算にする
                  //　・税込の場合、非課税項目を引く
                  const quote_subtotal_amt = add_other_data["ESTIMATE__other_tax_total_amt"] != "" && add_other_data["ESTIMATE__other_tax_total_amt"] > 0
                                              ? row_data.survey_tax_in_flag == 0  
                                                ? add_other_data["ESTIMATE__other_tax_total_amt"] + row_data.quote_tax_amt  //税別 
                                                : add_other_data["ESTIMATE__other_tax_total_amt"] //税込
                                              : row_data.survey_tax_in_flag == 0
                                                ? row_data.quote_subtotal_amt + row_data.quote_tax_amt //税別 
                                                : row_data.quote_subtotal_amt //税込
                  let {
                      PROJECT__project_natural_id,
                      PROJECT__construction_number,
                      PROJECT__site_name,
                      JOIN_project_addr
                  } = await Request.getProject(row_data.project_natural_id)


                  //H03対応
                  if (customInvoiceList){
                    object_array_detail[`row_start_${i}`] = {
                      CUSTOMER_BRANCH__customer_branch_name: row_data.customer_branch_name,
                      PROJECT__site_name,
                      ESTIMATE__survey_parking_name: row_data.survey_parking_name,
                      ESTIMATE__survey_parking_address_contract: row_data.survey_parking_address_contract,
                      JOIN_parking_addr: FormatCode.decode("cst_prefecture", row_data.survey_parking_prefecture) + (row_data.survey_parking_city?row_data.survey_parking_city:"") + (row_data.survey_parking_address?row_data.survey_parking_address:""),
                      REQUEST__request_type: FormatCode.decode("cst_request_type",row_data.request_type),
                      ESTIMATE__survey_parking_rent: row_data.survey_parking_rent,
                      ESTIMATE__survey_key_money: row_data.survey_key_money,
                      ESTIMATE__survey_commission: row_data.survey_commission,
                      ESTIMATE__quote_capacity_qty: row_data.quote_capacity_qty,
                      ESTIMATE__quote_available_start_date:  row_data.quote_available_start_date,
                      ESTIMATE__quote_available_end_date: row_data.quote_available_end_date,                      
                      ESTIMATE__survey_capacity_qty_type: FormatCode.decode("cst_survey_capacity_qty_type",row_data.survey_capacity_qty_type),
                      ESTIMATE__quote_subtotal_amt: quote_subtotal_amt,
                      ESTIMATE__quote_tax_amt: row_data.quote_tax_amt,
                      ESTIMATE__quote_total_amt: row_data.quote_total_amt,
                      ESTIMATE__survey_discount_amt: row_data.survey_discount_amt,
                      ESTIMATE__survey_tax_in_flag: FormatCode.decode("cst_tax_in_flag",row_data.survey_tax_in_flag),
                      ESTIMATE__survey_fraction_amt_flag: row_data.survey_fraction_amt_flag,
                      CALC__survey_parking_rent_total: _survey_parking_rent_total,
                      ...add_other_data
                    } 
                  }else{
                    object_array_detail[`row_start_${i}`] = {
                      PROJECT__construction_number,
                      INVOICE__invoice_natural_id: row_data.invoice_natural_id,
                      CUSTOMER_USER__customer_user_name: row_data.customer_user_name,
                      PROJECT__site_name,
                      JOIN_project_addr,
                      ESTIMATE__survey_parking_name: row_data.survey_parking_name,
                      ESTIMATE__quote_capacity_qty: row_data.quote_capacity_qty,
                      ESTIMATE__quote_available_start_date:  row_data.quote_available_start_date,
                      ESTIMATE__quote_available_end_date: row_data.quote_available_end_date,
                      ESTIMATE__quote_subtotal_amt: quote_subtotal_amt,
                      ESTIMATE__quote_tax_amt: row_data.quote_tax_amt,
                      ESTIMATE__quote_total_amt: row_data.quote_total_amt,
                      REQUEST__request_type: FormatCode.decode("cst_request_type",row_data.request_type),
                      ESTIMATE__survey_commission: row_data.survey_commission,
                      ESTIMATE__survey_commission_discount_rate: row_data.survey_commission_discount_rate,
                      ESTIMATE__survey_commission_discount_amt: row_data.survey_commission_discount_amt,
                      ESTIMATE__survey_tax_in_flag: FormatCode.decode("cst_tax_in_flag",row_data.survey_tax_in_flag),
                      ESTIMATE__survey_fraction_amt_flag: row_data.survey_fraction_amt_flag,
                      CALC__survey_parking_rent_total: 0,
                      ...add_other_data
                    }
  
                  }
                  up_data.push(row_data.invoice_natural_id);
                  
                }else{
                  //H03対応
                  if (customInvoiceList){
                    object_array_detail[`row_start_${i}`] = {
                      CUSTOMER_BRANCH__customer_branch_name:"",
                      PROJECT__site_name:"",
                      ESTIMATE__survey_parking_name: "",
                      ESTIMATE__survey_parking_address_contract:"",
                      JOIN_parking_addr:"",
                      REQUEST__request_type: "",
                      ESTIMATE__survey_parking_rent: "",
                      ESTIMATE__survey_key_money: "",
                      ESTIMATE__survey_commission: "",
                      ESTIMATE__quote_capacity_qty: "",
                      ESTIMATE__quote_available_start_date:  "",
                      ESTIMATE__quote_available_end_date: "",                      
                      ESTIMATE__survey_capacity_qty_type: "",
                      ESTIMATE__quote_subtotal_amt: "",
                      ESTIMATE__quote_tax_amt: "",
                      ESTIMATE__quote_total_amt: "",
                      ESTIMATE__survey_discount_amt:"",
                      ESTIMATE__survey_tax_in_flag: "",
                      ESTIMATE__survey_fraction_amt_flag: "",
                      CALC__survey_parking_rent_total: "",
                      ...add_other_data
                    }                     
                  }else{
                    object_array_detail[`row_start_${i}`] = {
                      PROJECT__construction_number: "",
                      INVOICE__invoice_natural_id: "",
                      CUSTOMER_USER__customer_user_name: "",
                      PROJECT__site_name: "",
                      JOIN_project_addr: "",
                      ESTIMATE__survey_parking_name: "",
                      ESTIMATE__quote_capacity_qty: "",
                      ESTIMATE__quote_available_start_date: "",
                      ESTIMATE__quote_available_end_date: "",
                      ESTIMATE__quote_subtotal_amt: "",
                      ESTIMATE__quote_tax_amt: "",
                      ESTIMATE__quote_total_amt: "",
                      REQUEST__request_type: "",
                      ESTIMATE__survey_commission: "",
                      ESTIMATE__survey_commission_discount_rate: "",
                      ESTIMATE__survey_commission_discount_amt: "",
                      ESTIMATE__survey_tax_in_flag: "",
                      ESTIMATE__survey_fraction_amt_flag: "",
                      CALC__survey_parking_rent_total: "",
                      ...add_other_data
                    }
  
                  }
  
                }

              }
              //  H03　URL設定
              let set_format_url = ""
              if (customInvoiceList){
                set_format_url =  GoogleDrive.getFormatUrl(format_url.H03_PDF)
              }else{
                set_format_url =  GoogleDrive.getFormatUrl(invoiceCommon.CUSTOMER_BRANCH__invoice_list_format_url
                  ?invoiceCommon.CUSTOMER_BRANCH__invoice_list_format_url
                  :customInvoiceList ? format_url[customInvoiceList.format] :format_url.G06_PDF)
              }
              let request = {
                ...invoiceCommon,
                format_url:set_format_url,
                object_each_data : {object_array_detail: object_array_detail},
                object_common:{
                  ...invoiceCommon.object_common,
                  array_count:data.length
                }
              }
              
              let G06_PDF = {}
              G06_PDF = await new Promise((resolve, reject)=>{
                Request.post( `/api/pout/${customInvoiceList ? customInvoiceList.format : "G06_PDF"}`,request , res=>{
                  // progressPercent = progressPercent + 90/(data.length*4) 
                  Request.setProgress(Math.floor(progressPercent))
                  resolve(res)
                }, err => {
                  reject(err)
                })
              })
              if(G06_PDF.Code >= 800){
                return null;
              }
            //データ更新
            // console.log(invoice_customer_user_id)
            let updateParams = {
              invoice_list_pdf_url : G06_PDF.Data ? G06_PDF.Data.spreadsheet_id : null,
              invoice_natural_id_array:up_data,
              update_timestamp:update_timestamp,
              invoice_customer_user_id:invoice_customer_user_id != null ? invoice_customer_user_id : undefined
            }
            // console.log(updateParams)
            let updateResult = await new Promise((resolve, reject)=>{
              Request.post(`/api/invoice/ListReport`, {...updateParams}, 
              (res)=>{
                resolve(res)
              },
              (err)=>{
                reject(err)
              })
            })


              return {G06_PDF,updateResult}
            })

          ).then((result)=>{
            Request.setProgress(0)
            console.log("result ", result)

            if(pdfErrorList.length > 0 ){
              this.props.alertModal.current.showErrorModal({
                title: "エラー",
                message: `${GetMessage(2467)}</br>${pdfErrorList.join("</br>")}`
              }, ()=>{}, false)
            } else {
              this.props.alertModal.current.confirmCheck({
                title: "処理完了",
                messageNo: 2417,
                closeBtn: false
              }, ()=>{}, false)
            }
          }).catch((error)=>{
            console.log("error ", error)
          }).finally(()=>{
              Request.setProgress(0)
              this.handleClickNegative();
              document.body.style.overflow = "auto";
              this.props.refreshCallback()
          })
        }else{
          if(pdfErrorList.length > 0 ){
            this.props.alertModal.current.showErrorModal({
              title: "エラー",
              message: `${GetMessage(2467)}</br>${pdfErrorList.join("</br>")}`
            }, ()=>{}, false)
          } else {
            this.props.alertModal.current.confirmCheck({
              title: "処理完了",
              messageNo: 2417,
              closeBtn: false
            }, ()=>{}, false)
          }
          Request.setProgress(0)
        }

      }).catch((error)=>{
        console.log("error ", error)
      }).finally(()=>{
        if (this.props.listGroup.length == 0) {
          Request.setProgress(0)
          this.handleClickNegative();
          document.body.style.overflow = "auto";
          this.props.refreshCallback()
        }
      })
    } else if (this.props.title==="請求処理待ちに"){
      const url = '/api/invoice/status'
      const checked_data = this.props.runData.map((datum)=>{
        return {
          invoice_ulid:datum.prop.ulid,
          updatetimestamp:datum.prop.update_timestamp,
        }
      },[])
      Request.post(url, { 
        checked_data,
        invoice_process_status:INVOICE_PROCESS_STATUS.WAITING_PROCESS
      }, res => {
        this.handleClickNegative();
        document.body.style.overflow = "auto";
        this.props.refreshCallback()
      });
    } else if (this.props.title==="請求済に"){
      const url = '/api/invoice/status'
      const checked_data = this.props.runData.map((datum)=>{
        const {
          invoice_list_create_flag,
          invoice_list_create_type,
          invoice_customer_user_setting,
          invoice_customer_user_id: origin_invoice_customer_user_id,
          customer_list_invoice_customer_user_id: origin_customer_list_invoice_customer_user_id,
          invoice_list_customer_branch_id,
          customer_branch_id
        } = datum.prop
        // 一覧請求作成　かつ　顧客単位　でサブ支店の場合　メイン支店の請求担当　それ以外は　実施支店の請求担当
        const invoice_customer_user_id = invoice_list_create_flag == 1 && 
                                         invoice_list_create_type == 1 && 
                                         parseInt(invoice_list_customer_branch_id) != parseInt(customer_branch_id)
                                         ? origin_customer_list_invoice_customer_user_id 
                                         : origin_invoice_customer_user_id 
                                           ? origin_invoice_customer_user_id
                                           : null
        console.log(datum,invoice_customer_user_id)
        return {
          invoice_ulid:datum.prop.ulid,
          updatetimestamp:datum.prop.update_timestamp,
          invoice_customer_user_id:invoice_customer_user_id != null ? invoice_customer_user_id : undefined
        }
      },[])
      Request.post(url, { 
        checked_data,
        invoice_process_status:INVOICE_PROCESS_STATUS.INVOICED
      }, res => {
        this.handleClickNegative();
        document.body.style.overflow = "auto";
        this.props.refreshCallback()
      });
    } else if (this.props.title==="請求をキャンセル"){
      const url = '/api/invoice/status'
      const checked_data = this.props.runData.map((datum)=>{
        return {
          invoice_ulid:datum.prop.ulid,
          updatetimestamp:datum.prop.update_timestamp,
        }
      },[])
      Request.post(url, { 
        checked_data,
        invoice_process_status:INVOICE_PROCESS_STATUS.CANCEL
      }, res => {
        this.handleClickNegative();
        document.body.style.overflow = "auto";
        this.props.refreshCallback()
      });
    } else if (this.props.title==="請求先変更済み書類（送付状・請求書・契約書）を生成"){
      let progressPercent = 10;
      
      Promise.all(this.props.runData.map(async (datum)=>{
        const {
          estimate_natural_id,
          request_natural_id,
          customer_natural_id,
          customer_user_natural_id,
          customer_branch_natural_id,
          subcontract_customer_branch_natural_id,
          subcontract_customer_user_natural_id,
          project_natural_id,
          invoice_natural_id,
          invoice_amt,
          quote_available_start_date,
          quote_available_end_date,
          ulid,
          update_timestamp,
          request_type,
          tax_in_flag,
          payment_due_rule_month,
          payment_due_rule_day,

          customer_branch_name,
          invoice_customer_user_name,
          change_invoice_name,
          invoice_process_pdf_date : origin_invoice_process_pdf_date,
          invoice_process_status,
          user_branch_natural_id,
          estimate_payment_deadline
        } = datum.prop

        const { 
          invoice_closing_date, 
          invoice_process_pdf_date, 
          payment_deadline 
        } = this.calcPaymentDeadline(payment_due_rule_month, payment_due_rule_day, estimate_payment_deadline);

        Request.setProgress(Math.floor(progressPercent))
        const invoiceCustomerBranch = await Request.getCustomerBranch(customer_branch_natural_id,false);
        console.log(invoiceCustomerBranch);
        //請求共通パラメータ取得
        const invoiceCommon = await Request.getInvoiceCommon({
          customer_branch_natural_id,
          customer_user_natural_id,
          subcontract_customer_branch_natural_id,
          subcontract_customer_user_natural_id,
          request_natural_id,
          project_natural_id,
          invoice_natural_id,
          invoice_process_pdf_date,
          estimate_natural_id,
          quote_available_start_date,
          quote_available_end_date,
          request_type,
          payment_deadline,
          invoice_closing_date,
          invoice_amt,
          user_branch_natural_id,
        })

        const {
          CUSTOMER_BRANCH__customer_branch_invoice_zip_code,
          JOIN_invoice_addr,
          invoice_create_flag,
          contract_create_flag,
        } = invoiceCustomerBranch;

        // G13_PDF_請求書送付状
        const G13_PDF = await new Promise((resolve, reject)=>{
          Request.post('/api/pout/G13_PDF', {
            ...invoiceCommon,
            object_each_data:{
              CUSTOMER_BRANCH__customer_branch_invoice_zip_code,
              JOIN_invoice_addr,
              CUSTOMER_USER__customer_user_name : invoice_customer_user_name,
              ESTIMATE__change_invoice_name : change_invoice_name
            },
            format_url:GoogleDrive.getFormatUrl(format_url.G13_PDF),
          }, res=>{
            progressPercent = progressPercent + 90/(this.props.runData.length*3) 
            Request.setProgress(Math.floor(progressPercent))
            resolve(res)
          }, err => {
            resolve({
              estimate_natural_id : estimate_natural_id,
              Code : 805,
            })
          })
        })
        if(G13_PDF.Code >= 800){
          return G13_PDF;
        }

        // G04_PDF_請求書
        let G14_PDF = {};

        // G04_PDF_請求書個別パラメータ取得
        const estimate_data = await new Promise((resolve, reject)=>{
          Request.get('/api/order', {
            estimate_natural_id,
            extension_flag:1
          }, res=>{
            if (!res.Data[0]){
              resolve({
                estimate_natural_id : estimate_natural_id,
                Code : 805,
              })
            }
            resolve(res.Data[0])
          }, err => {
            resolve({
              estimate_natural_id : estimate_natural_id,
              Code : 805,
            })
          })
        })

        if(estimate_data.Code >= 800){
          return {
            estimate_natural_id : estimate_natural_id,
            Code : 805,
          }
        }
        const object_each_data = {
          ESTIMATE__survey_commission_discount_amt : estimate_data.survey_commission_discount_amt,
          ESTIMATE__quote_subtotal_amt : estimate_data.quote_subtotal_amt,
          ESTIMATE__quote_tax_amt : estimate_data.quote_tax_amt,
          ESTIMATE__quote_total_amt : estimate_data.quote_total_amt,
          ESTIMATE__survey_parking_address_contract : estimate_data.survey_parking_address_contract,
          ESTIMATE__quote_plotting_number : estimate_data.quote_plotting_number,
          INVOICE__invoice_amt : invoice_amt,

          CUSTOMER_BRANCH__tax_in_flag : tax_in_flag,
          ESTIMATE__quote_available_start_date : estimate_data.quote_available_start_date,
          ESTIMATE__quote_available_end_date : estimate_data.quote_available_end_date,
          ESTIMATE__survey_capacity_qty_type : estimate_data.survey_capacity_qty_type,
          ESTIMATE__survey_discount_amt : estimate_data.survey_discount_amt,
          ESTIMATE__survey_key_money : estimate_data.survey_key_money,
          ESTIMATE__survey_adjustment_amt : estimate_data.survey_adjustment_amt,

          ESTIMATE__survey_commission_discount_rate : estimate_data.survey_commission_discount_rate,
          ESTIMATE__survey_commission : estimate_data.survey_commission,
          ESTIMATE__change_invoice_name : change_invoice_name,
          PROJECT__register_type : estimate_data.register_type,
        }

        const estimate_detail_data = await new Promise((resolve, reject)=>{
          // 確定見積詳細取得API呼び出し
          Request.get(`/api/estimate/detail/quote/${estimate_natural_id}`, {}, res=>{
            if (!res.Data[0]){
              resolve({
                estimate_natural_id : estimate_natural_id,
                Code : 805,
              })
            }
            resolve(res.Data)
          }, err => {
            resolve({
              estimate_natural_id : estimate_natural_id,
              Code : 805,
            })
          })
        })
        

        if(estimate_detail_data.Code >= 800){
          return {
            estimate_natural_id : estimate_natural_id,
            Code : 805,
          }
        }

        let object_array_detail_count = 11
        const {object_array_detail, array_count,add_other_data} = this.makeEstimateDetail(estimate_data, estimate_detail_data, object_array_detail_count, customer_branch_name, request_type);

        //請求書送付有無が有りのもの
        if(invoice_create_flag == "1"){

          G14_PDF = await new Promise((resolve, reject)=>{
            Request.post( `/api/pout/G14_PDF`, {
              ...invoiceCommon,
              format_url:GoogleDrive.getFormatUrl((invoiceCommon.CUSTOMER_BRANCH__invoice_format_url
                ?invoiceCommon.CUSTOMER_BRANCH__invoice_format_url
                :format_url.G14_PDF)),
              object_each_data : {
                ...object_each_data,
                ...add_other_data,
                object_array_detail
              },
              object_common:{
                ...invoiceCommon.object_common,
                array_count:array_count
              }
            }, res=>{
              progressPercent = progressPercent + 90/(this.props.runData.length*3) 
              Request.setProgress(Math.floor(progressPercent))
              resolve(res)
            }, err => {
              resolve({
                estimate_natural_id : estimate_natural_id,
                Code : 805,
              })
            })
          })
          if(G14_PDF.Code >= 800){
            return G14_PDF;
          }
        }
        
        let G15_PDF = {};
        //契約書送付有無が有りのもの
        if(contract_create_flag == "1"){
          //契約共通パラメータ取得
          const contractCommon = await Request.getContractCommon({
            customer_branch_natural_id,
            customer_user_natural_id,
            subcontract_customer_branch_natural_id,
            subcontract_customer_user_natural_id,
            request_natural_id,
            project_natural_id,
            invoice_natural_id,
            invoice_process_pdf_date,
            estimate_natural_id,
            quote_available_start_date,
            quote_available_end_date,
            request_type,
            payment_deadline,
            invoice_closing_date,
            invoice_amt,
          })

          // G15_PDF
          G15_PDF = await new Promise((resolve, reject)=>{
            Request.post( `/api/pout/G15_PDF`, {
              ...contractCommon,
              object_each_data : {
                ...object_each_data,
                ...add_other_data
              },
              format_url:GoogleDrive.getFormatUrl((invoiceCommon.CUSTOMER_BRANCH__contract_format_url
                ?invoiceCommon.CUSTOMER_BRANCH__contract_format_url
                :format_url.G15_PDF)),
            }, res=>{
              progressPercent = progressPercent + 90/(this.props.runData.length*3) 
              Request.setProgress(Math.floor(progressPercent))
              resolve(res)
            }, err => {
              resolve({
                estimate_natural_id : estimate_natural_id,
                Code : 805,
              })
            })
          })
          if(G15_PDF.Code >= 800){
            return G15_PDF;
          }
        }

        let updateResult = {}
        const updateParams = {
          change_send_letter_pdf_url : G13_PDF.Data ? G13_PDF.Data.spreadsheet_id : null,
          change_invoice_pdf_url : G14_PDF.Data ? G14_PDF.Data.spreadsheet_id : null,
          change_contract_pdf_url : G15_PDF.Data ? G15_PDF.Data.spreadsheet_id : null,
          invoice_ulid:ulid,
          update_timestamp:update_timestamp,
          invoice_process_status : invoice_process_status === INVOICE_PROCESS_STATUS.REQUESTED ? INVOICE_PROCESS_STATUS.GENERATED : invoice_process_status, //　依頼済みの場合は請求書生成済みにする、以外は更新しない
          invoice_process_pdf_date : origin_invoice_process_pdf_date ? origin_invoice_process_pdf_date : invoice_process_pdf_date, // 請求書生成日
          invoice_process_pdf_lastupdate : moment().format("YYYY-MM-DDTHH:mm:ss"), // 請求書PDF最終変更日
          invoice_closing_date : this.props.invoice_closing_date, // 請求書締日（請求書発行日）
          payment_deadline : payment_deadline, // 支払期限日
        }
        updateResult = await new Promise((resolve, reject)=>{
          Request.put(`/api/invoice/${ulid}`, updateParams, 
          (res)=>{
            resolve(res)
          },
          (err)=>{
            resolve({
              estimate_natural_id : estimate_natural_id,
              Code : 805,
            })
          })
        })
        return {
          G13_PDF,
          G14_PDF,
          G15_PDF,
          updateResult
        }
      }))
      .then((result) => {
        console.log("res ", result)

        // pdf生成失敗した見積IDを取得する
        const pdfErrorList = result.filter(item => item.Code >= 800).map((item => (item.estimate_natural_id)))
        document.body.style.overflow = "auto";
        if(pdfErrorList.length > 0 ){
          this.props.alertModal.current.showErrorModal({
            title: "エラー",
            message: `${GetMessage(2467)}</br>${pdfErrorList.join("</br>")}`
          }, ()=>{}, false)
        } else {
          this.props.alertModal.current.confirmCheck({
            title: "処理完了",
            messageNo: 2417,
            closeBtn: false
          }, ()=>{}, false)
        }
        Request.setProgress(0)
      })
      .catch((error)=>{
        console.log("error ", error)
      })
      .finally(() => {
        Request.setProgress(0)
        this.handleClickNegative();
        document.body.style.overflow = "auto";
        this.props.refreshCallback()
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.title !== this.props.title){
      this.setState({
        title:"チェックした確定見積について"+this.props.title+'します。',

      });
    }
  }

  bodyContent() {
    let message = "";
    let cntList = 0;
    let noInvoiceUser = [];
    let noInvoiceAddress = [];
    if (this.props.title==="請求書を生成"){
      // message = "未処理、請求書作成済、請求処理待ち、請求済、請求キャンセル済、請求ロックONの見積は無視されます。よろしいですか？";
      // #1732
      message = "未処理、請求書作成済、請求処理待ち、請求済、請求キャンセル済、請求ロックONの見積、または契約書UL待ちから区画番号変更によりチェックへ移動したものは無視されます。よろしいですか？";
      cntList = this.props.listGroup.length;
      // console.log(cntList);

    } else if (this.props.title==="請求処理待ちに"){
      message = "未処理、請求処理待ち、請求済、請求キャンセル済、請求ロックONの見積は無視されます。よろしいですか？"
    } else if (this.props.title==="請求済に"){
    // 20250326 #2244対応
      noInvoiceUser =  this.props.noInvoiceUser
      console.log(noInvoiceUser)
      noInvoiceAddress =  this.props.noInvoiceAddress

      message = "未処理、請求依頼済、請求済、請求キャンセル済の見積は無視されます。よろしいですか？"
      // message = "未処理、請求依頼済、請求処理待ちかつ請求書未作成、請求済、請求キャンセル済の見積は無視されます。よろしいですか？"
    } else if (this.props.title==="請求をキャンセル"){
      message = "請求キャンセル済、請求ロックONの見積は無視されます。よろしいですか？"
    } else if (this.props.title==="請求先変更済み書類（送付状・請求書・契約書）を生成"){
      message = "未処理、請求キャンセル、請求先名が変更されてない見積、請求ロックONは無視されます。よろしいですか？"
    } 

    const alertMessage = this.props.ignoreData.map((item) => (<div>見積ID：{item.prop.invoice_natural_id}</div>))
    return (
      <>
        <div>{message}</div>
        <div>実行する件数　{this.props.runData.length}件　無視する件数　{this.props.checkedData.length - this.props.runData.length}件</div>
        <div>一覧帳票数　{cntList}件（該当レコード数　{this.props.listData.length}件）</div>
        {/* {noInvoiceAddress.length > 0 && <div>{GetMessage(2458)}</div>}         */}
        {noInvoiceUser.length > 0 && <div style={{color:'red'}}>{GetMessage(2456)}</div>}
        {noInvoiceAddress.length > 0 && <div style={{color:'red'}}>{GetMessage(2458)}</div>}
        {(alertMessage.length > 0) && <><br/><div style={{color:'red'}}>※以下の一部入金、入金済の見積は無視されます</div><div>{alertMessage}</div></>}
      </>
    );
  }
}

class DialogCancelInvoice extends DialogBase {
  constructor(props) {
    super(props);
    Object.assign(this.state, {
      title: '請求をキャンセルします。',
      data: {
        values:{
          invoice_cancel_date: undefined,
          refund_amt: undefined,
          refund_date: undefined,
        },
        errors:{invoice_cancel_date : [GetMessage(2024)]},
        requiredData:{}
      }
    });
    this.setState({
      inProcess : true
    })
    this.validateCallback = this.validateCallback.bind(this)
    this.validate = this.validate.bind(this)
    
  }

  componentDidUpdate(prevProps){
    // console.log(this.state.data);
    if (prevProps.data !== this.props.data){

      this.setState({
        data: {
          ...this.state.data,
          values: {
            invoice_cancel_date: this.props.data.values?.invoice_cancel_date ?? this.state.data.values.invoice_cancel_date,
            refund_amt: this.props.data.values?.refund_amt ?? this.state.data.values.refund_amt,
            refund_date: this.props.data.values?.refund_date ?? this.state.data.values.refund_date,
          },
          errors:{invoice_cancel_date : [GetMessage(2024)]},
          // requiredData:{...(this.state.data.values.invoice_cancel_date ? {invoice_cancel_date : [GetMessage(2024)]} : undefined) },
          requiredData:{invoice_cancel_date : [GetMessage(2024)]},
          inProcess : false
        },
      })
    }
  }
  handleClickNegative(){
    this.setState(prevState=>({
      data:{
        ...this.state.data,
        values:{
          ...this.state.data.values,
          invoice_cancel_date: undefined,
          refund_amt: undefined,
          refund_date: undefined,
        },
        errors:{invoice_cancel_date : [GetMessage(2024)]},
        requiredData:{invoice_cancel_date : [GetMessage(2024)]},
        inProcess : false
      }
    }),this.toggleModal());
  }

  validateCallback(newData, callback=()=>{}){
    console.log(newData);
    this.setState({
      data:{
        ...this.state.data,
        ...newData,
        values: {
          ...this.state.data.values,
          ...newData.values,
        },
      }
    }, ()=>callback())
  }
  validate(){
    let message = getErrorCodes(this.state.data.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  async handleClickPositive(){
    // 連続送信対策
    if(this.state.inProcess){
      return;
    }
    // エラーチェック
    if (!this.validate()){
      return;
    }

    const url = '/api/invoice/status'
    const checked_data = this.props.runData.map((datum)=>{
      return {
        invoice_ulid:datum.prop.ulid,
        updatetimestamp:datum.prop.update_timestamp,
      }
    },[])

    Request.post(url, {
      checked_data,
      invoice_process_status:INVOICE_PROCESS_STATUS.CANCEL,
      invoice_cancel_date: this.state.data.values.invoice_cancel_date,
      refund_amt: this.state.data.values.refund_amt,
      refund_date: this.state.data.values.refund_date,
    }, res => {
      if (res.Code == 816){
        this.props.alertModal.current.confirmCheck({
          title: res.data.message,
          messageNo: 2616,
          closeBtn: false
        }, ()=>{
          this.props.refreshCallback()　//コレは元々の処理
        }, false)
      }else{
        console.log(res.data);
        const {ex_andpad_use_flag, 
              ex_andpad_access_token_key, 
              register_type, 
              ex_andpad_system_id,
              estimate_natural_id,
              ex_andpad_estimate_delete_flag,
              ex_andpad_plotting_delete_flag,
              ex_andpad_quote_delete_flag
              } = res.data;
        const andpad_use_flag = ex_andpad_use_flag == 1 && 
                                ex_andpad_access_token_key != "" && 
                                ex_andpad_access_token_key != null &&
                                ex_andpad_system_id != "" && 
                                ex_andpad_system_id != null &&
                                parseInt(register_type) == 1 &&
                                ex_andpad_estimate_delete_flag == 0 &&
                                ex_andpad_plotting_delete_flag == 0 ? true : false;
        console.log("andpad_use_flag ", andpad_use_flag)
        console.log("data ", res.data)
        this.handleClickNegative();
        document.body.style.overflow = "auto";
        this.props.refreshCallback(andpad_use_flag, andpad_use_flag ? estimate_natural_id : null);
      }
    });
  }

  bodyContent() {
    return (
      <>
        <Table>
          <tbody>
          <tr>
              <CustomTd label='請求キャンセル実施日'
                    name='ESTIMATE__invoice_cancel_date'
                    copy={false}
                    rootData={this.state.data}
                    value={
                      <InputDatetime
                        validateCallback={this.validateCallback} 
                        validateType='regist'
                      />
                    }
                />
            </tr>
            <tr>
              <CustomTd label='返金予定額'
                name='ESTIMATE__refund_amt'
                copy={false}
                rootData={this.state.data}
                value={
                  <InputNumber
                    disabled={this.props.paymentAllDone}
                    validateCallback={this.validateCallback} 
                    validateType='regist'
                    unit="円"
                  />
                }
              />
            </tr>
            <tr>
              <CustomTd label='返金予定日'
                    name='ESTIMATE__refund_date'
                    copy={false}
                    rootData={this.state.data}
                    value={
                      <InputDatetime
                        disabled={this.props.paymentAllDone}
                        validateCallback={this.validateCallback} 
                        validateType='regist'
                      />
                    }
                />
            </tr>
          </tbody>
        </Table>
        <Row style={{marginBottom: "0.5rem"}}>
          <Col md="12">
            {this.props.paymentAllDone == false &&
              <div style={{color: "#ec250d"}}>仕入実施済の場合、売上取消となります</div>
            }
          </Col>
        </Row>
      
      </>
    );
  }
}

class DialogInvoice extends DialogBase {
  constructor(props) {
    super(props);
    Object.assign(this.state, {
      title: '請求書アップロード',
      data: this.props.data,
      cuFiles : []
      // disablePositive:false
    });
    this.validateCallback = this.validateCallback.bind(this)

    this.DELETE_LINK_STATUS = 0
    this.REACTIVATE_LINK_STATUS = 1
    this.INVOICE_FILE_TYPE = 6
    this.INVOICE_EXEC_REPORT = "G04"
  }

  async componentDidUpdate(prevProps){
    const {INVOICE_FILE_TYPE} = this

    if (prevProps.data !== this.props.data){

      // ファイル情報取得
      Request.get('/api/cufile', { ref_id : this.props.data.values.id, file_type : INVOICE_FILE_TYPE  }, res => {
        this.setState({
          cuFiles : res.Data
        })
      })

      this.setState({
        data: {
          values:{
            ...this.props.data.values,
            send_upload_notification:false
          },
          errors:{
            invoice:[GetMessage(2024)]
          },
          requiredData:{
            invoice:[GetMessage(2024)],
          }
        },
      })
    }
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      data:{
        ...this.state.data,
        ...newData
      },
    }, ()=>callback())
  }

  validate(){
    let message = getErrorCodes(this.state.data.errors)

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  async handleClickPositive(){
    const {INVOICE_EXEC_REPORT} = this

    if(!this.validate()){
      return;
    }
    Request.setProgress(10)

    const {
      customer_id,
      customer_branch_id,
      customer_branch_natural_id,
      customer_user_id,
      customer_user_natural_id,
      estimate_natural_id,
      subcontract_customer_branch_natural_id,
      subcontract_customer_user_natural_id,
      quote_available_start_date,
      quote_available_end_date,
      request_user_branch_natural_id:user_branch_natural_id,
      id,
      invoice,
      invoice_base64,
      invoice_natural_id,
      invoice_process_pdf_date,
      invoice_closing_date,
      invoice_amt,
      request_natural_id,
      request_type,
      project_natural_id,
      payment_deadline,
      want_guide_type,
      want_guide_type_subcontract,
      invoice_customer_user_id,
      invoice_notification_flag,
      invoice_customer_reminder_sms_flag,
      invoice_customer_user_tel,
      invoice_customer_user_email,
      invoice_customer_user_name,
      invoice_customer_system_use_flag
    } = this.state.data.values    

    // 担当者マスタのSMSリマインド送信有無が送信するかつ携帯電話番号がある場合
    let isPushAllowedCust = invoice_customer_system_use_flag == 1 && invoice_notification_flag === 1 ? true : false;
    let isSmsAllowedCust = (invoice_customer_reminder_sms_flag === 1 && invoice_customer_user_tel) ? true : false;
    if(isPushAllowedCust){
      isSmsAllowedCust = false;
    }

    Request.setProgress(20)

    try {
      const useCustomerSystem = Boolean(this.state.data.values.customer_system_use_flag)
      const sendUploadNotification = Boolean(this.state.data.values.send_upload_notification)
      const wasFileUploaded = this.state.data.values["invoice_base64"] !== undefined

      Request.setProgress(40)

      let resultSms = {Code:200}

      if(sendUploadNotification){
  
        const invoiceCommon = await Request.getInvoiceCommon({
          customer_branch_natural_id,
          customer_user_natural_id,
          subcontract_customer_branch_natural_id,
          subcontract_customer_user_natural_id,
          request_natural_id,
          project_natural_id,
          invoice_natural_id,
          invoice_process_pdf_date,
          estimate_natural_id,
          quote_available_start_date,
          quote_available_end_date,
          request_type,
          payment_deadline,
          invoice_closing_date,
          invoice_amt,
          user_branch_natural_id
        })

        Request.setProgress(50)

        if(useCustomerSystem && sendUploadNotification){
        
          const g20_mail = await new Promise((resolve, reject)=>{
            
            const mailUrl = '/api/pout/G20_MAIL'
            const mailParams = {
              ...invoiceCommon,
              format_url:GoogleDrive.getFormatUrl(format_url.G20_MAIL),
              send_destination_type:0, // 通知は元請けのみ
              want_guide_type,
              want_guide_type_subcontract,
              ESTIMATE__latest_pdf_quote_url: null,
              object_each_data:{
                INVOICE_USER__customer_user_name:invoice_customer_user_name,
                INVOICE_USER__customer_user_email:invoice_customer_user_email,
                INVOICE_USER__customer_user_tel:invoice_customer_user_tel,
              }
            }
            
            Request.post(mailUrl, mailParams, res=> resolve(res), err=> reject(err))
          })  
  
          Request.setProgress(70)

          if(invoiceCommon.object_project.PROJECT__site_customer_user_tel){
            isSmsAllowedCust = true;
          }

          let g20_sms = false;
          
          if(isSmsAllowedCust || isPushAllowedCust){
            g20_sms =  await new Promise((resolve, reject)=>{
            
              const smsUrl = '/api/pout/G20_SMS'
              const smsParams = {
                ...invoiceCommon,
                format_url:GoogleDrive.getFormatUrl(format_url.G20_SMS),
                send_destination_type:0,
                object_each_data:{
                  INVOICE_USER__customer_user_name:invoice_customer_user_name,
                  INVOICE_USER__customer_user_email:invoice_customer_user_email,
                  INVOICE_USER__customer_user_tel:invoice_customer_user_tel,
                  INVOICE_USER__invoice_notification_flag:invoice_customer_system_use_flag == 1 && invoice_notification_flag === 1 ? 1 : 0,
                  INVOICE_USER__invoice_customer_reminder_sms_flag:invoice_customer_reminder_sms_flag,
                  INVOICE_USER__invoice_customer_user_id:invoice_customer_user_id,
                },
								push_flag: isPushAllowedCust ? 1 : 0,
              }
              
              Request.post(smsUrl, smsParams, res => resolve(res), err=> reject(err))
            })
          }
        
          Request.setProgress(90)
          
          const sendMail = g20_mail && await new Promise((resolve, reject)=>{
              
            const sendMailUrl = '/api/send/AUTOMAIL'
            const sendMailParams = g20_mail.data
      
            Request.post(sendMailUrl, sendMailParams, res=> resolve(res), err=> reject(err))
          })  
          const sendPush = isPushAllowedCust && g20_sms && await new Promise((resolve, reject)=>{
            const sendSmsUrl = '/api/send/PUSH'
            g20_sms.data && g20_sms.data.forEach((smsData)=>{
              if( smsData.type == "push"){
                const sendPushParams = {...smsData,customer_user_id:invoice_customer_user_id}
                Request.post(sendSmsUrl, sendPushParams, res=> resolve(res), err=> reject(err),undefined, true, false)
              }
            })
          }) 
          
          resultSms = isSmsAllowedCust && g20_sms && await new Promise((resolve, reject)=>{
            const sendSmsUrl = '/api/send/SMS'
            g20_sms.data && g20_sms.data.forEach((smsData)=>{
              if( smsData.type == "sms"){
                if (smsData.site_flag == true) {
                  if (smsData.site_error == true) {
                    resolve({Code: 2631})
                  }else{
                    Request.post(sendSmsUrl, smsData, res => {
                    if (res.Data && res.Data.sms_status == 'accepted'){
                      resolve({Code: 200})
                    }else{
                      resolve({Code: 2631, data: res.Data})
                    }
                    }, err => {
                      resolve({Code: 2631, data: err})
                    }, undefined, true, false)
                  }
                } else {
                  Request.post(sendSmsUrl, smsData, res=> {}, err=> {},undefined, true, false)
                }
              }

            })

          }) 

        }
      }
      const file_upload = wasFileUploaded && await new Promise((resolve, reject)=>{
        const file_upload_url = "/api/gcs_upload/attach"
        const uploadParams = {
          customer_id,
          ref_id:id,
          customer_branch_id,
          exec_report:INVOICE_EXEC_REPORT,
          customer_user_id,
          fileName:invoice,
          base64_str:invoice_base64
        }
        Request.post(file_upload_url, uploadParams, res => resolve(res), err => reject(err))
      })
      Request.setProgress(0)
      if (resultSms.Code == 200){
        this.props.alertModal.current.confirmCheck({
          title: "処理完了",
          messageNo: 2417,
        }, ()=>{
          this.toggleModal()
          this.props.refreshCallback()
        },false)
      } else {
        console.log(resultSms);
        let title = "エラー"
        let message = GetMessage(2631)
        if (resultSms.data && resultSms.data.sms != "") {
          message = message + "<br />\n" + resultSms.data.sms
        }
        this.props.alertModal.current.confirmCheck({
          title: title,
          message: message ,
          closeBtn: false
        }, () => {
          this.props.refreshCallback()
          this.toggleModal()
        }, false)
      }

    } catch (error) {
      Request.setProgress(0)
      this.props.alertModal.current.showErrorModal({
        messageNo: 2999
      })
    }
  }

  handleClickNegative(){
    this.props.handleClickNegative && this.props.handleClickNegative();
    this.setState({
      data:{
        ...this.state.data,
        invoice:"",
        invoice_base64:"",
      }
    })

    this.toggleModal()
  }

  handleDeleteLink(fileId){

    const [targetFile] = this.state.cuFiles.filter(file => file.file_id === fileId)
    targetFile["status"] = this.DELETE_LINK_STATUS

    Request.put(`/api/cufile/${fileId}`,targetFile,(res)=>{
      const updatedCuFiles = this.state.cuFiles.map(file =>{
        if(file.file_id === fileId){
          file.status = this.DELETE_LINK_STATUS
        }
        return file
      })
      
      this.setState({
        cuFiles:updatedCuFiles
      })
    })
  }

  handleReactivateLink(fileId){

    const [targetFile] = this.state.cuFiles.filter(file => file.file_id === fileId)
    targetFile["status"] = this.REACTIVATE_LINK_STATUS

    Request.put(`/api/cufile/${fileId}`,targetFile,(res)=>{

      const updatedCuFiles = this.state.cuFiles.map(file =>{
        if(file.file_id === fileId){
          file.status = this.REACTIVATE_LINK_STATUS
        }
        return file
      })
      
      this.setState({
        cuFiles:updatedCuFiles
      })
    })
  }

  bodyContent() {
    return (
      <>
        <InputFile 
          label="請求書"
          name="CU_FILE__invoice"
          copy={false}
          showLink={true}
          validateCallback={this.validateCallback} 
          rootData={this.state.data} />
        <div className="mt-1">
          <InputCheckBox 
              label="請求書アップロード通知を送る"
              name="NODB__send_upload_notification" 
              validateCallback={this.validateCallback} 
              checkedValue={true}
              uncheckedValue={false}
              rootData={this.state.data}
              // disabled={!Boolean(this.state.data.values.customer_system_use_flag)}
            />
        </div>

        {this.state.cuFiles.map((file, index) => (
          <Row key={index}>
              <Col>
                <a className={file.status === 0 ? "disabled-link":""} href={`/api/gcs_download/${file.file_path}?d=${file.file_name}`} target="_blank">{file.file_name}</a>      
              </Col>
              <Col>
                <Button onClick={()=>{this.handleDeleteLink(file.file_id)}}color="danger" size="sm" disabled={file.status === 0}>削除</Button>
                <Button onClick={()=>{this.handleReactivateLink(file.file_id)}} className="ml-3" color="secondary" size="sm" disabled={file.status === 1}>戻す</Button>
              </Col>
          </Row>
        ))}
        <br/>
      </>
    );
  }
}

export class DialogInvoiceCsvDownload extends DialogBase {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      csvData : [[]],
      dialogData : {
        values : {},
        errors : {},
        requiredData : {}
      }
    });

    this.csvDownloader = React.createRef();
    this.validateCallback = this.validateCallback.bind(this)
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dialogTitle !== this.props.dialogTitle || prevState.modal !== this.state.modal){
      this.setState({
        title: '一覧CSV出力をします。よろしいですか？',
      });
    }
  }

  validate(){
    let message = getErrorCodes(this.state.dialogData.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      dialogData:{
        ...this.state.dialogData,
        ...newData
      }
    }, ()=>callback())
  }

  makeCsv(invoices){
    const csvData = invoices.reduce((acc, data) => {

      let quote_subtotal_amt = this.isNullOrUndefined(data.quote_subtotal_amt) ? 0 : parseInt(data.quote_subtotal_amt)
      let estimate_detail_amt_ex = this.isNullOrUndefined(data.estimate_detail_amt_ex) ? 0 : data.estimate_detail_amt_ex

      acc.push([
        this.isNullOrUndefined(data.estimate_natural_id) ? "" : data.estimate_natural_id,
        this.isNullOrUndefined(data.due_day_rule) ? "" : FormatCode.decode("cst_due_day_rule", data.due_day_rule),
        this.isNullOrUndefined(data.due_day) ? "" : data.due_day,
        this.isNullOrUndefined(data.invoice_process_status) ? "" : FormatCode.decode("cst_invoice_process_status", data.invoice_process_status),
        this.isNullOrUndefined(data.invoice_payment_finish_date) ? "" : moment(data.invoice_payment_finish_date).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.invoice_process_pdf_date) ? "" : moment(data.invoice_process_pdf_date).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.invoice_closing_date) ? "" : moment(data.invoice_closing_date).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.payment_deadline) ? "" : moment(data.payment_deadline).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.quote_available_start_date) ? "" : moment(data.quote_available_start_date).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.quote_available_end_date) ? "" : moment(data.quote_available_end_date).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.invoice_amt) ? 0 : data.invoice_amt,
        this.isNullOrUndefined(data.survey_tax_in_flag) ? '税別' : (data.survey_tax_in_flag == 0 ? '税別' : '税込'), // 確定見積：税込・税抜区分
        quote_subtotal_amt-estimate_detail_amt_ex, // 確定見積：課税金額
        this.isNullOrUndefined(data.quote_tax_amt) ? 0 : data.quote_tax_amt, // 確定見積：税額（税抜きの場合）
        estimate_detail_amt_ex, // 確定見積：非課税金額
        this.isNullOrUndefined(data.invoice_customer_name) ? "" : data.invoice_customer_name,
        this.isNullOrUndefined(data.invoice_customer_branch_name) ? "" : data.invoice_customer_branch_name,
        this.isNullOrUndefined(data.invoice_customer_user_name) ? "" : data.invoice_customer_user_name,
        this.isNullOrUndefined(data.construction_number) ? "" : data.construction_number,
        this.isNullOrUndefined(data.site_name) ? "" : data.site_name,
        this.isNullOrUndefined(data.invoice_memo) ? "" : data.invoice_memo,
        this.isNullOrUndefined(data.invoice_user_memo) ? "" : data.invoice_user_memo,
        this.isNullOrUndefined(data.payment_user_memo) ? "" : data.payment_user_memo,
        this.isNullOrUndefined(data.invoice_note) ? "" : data.invoice_note
      ])
      return acc
    }, [[...INVOICE_CSV.HEADER]])

    return this.wrappingQuote(csvData);
  }

  isNullOrUndefined(data){
    if(data === undefined || data === null){
      return true;
    }
    return false;
  }

  wrappingQuote = (dataArray) => {
    return dataArray.map(data => 
      data.map((data => {
        if(data===""){
          return data
        } else {
          return '"'+data+'"'
      }})
    ))
  }

  bodyContent() {
    return (
      <>
        <div className="modal-box">
          <Button color="secondary" onClick={this.handleClickNegative}>キャンセル</Button>
          <Button color="info" onClick={async ()=> {
            if(!this.validate()){
              return;
            }

            const search_params = {
              ...this.props.search_params(),
              isCsv : true
            }
            const searched_data = await new Promise((resolve, reject)=> {
              Request.get(`/api/invoice`, search_params , res => {
                console.log(res.Data)
                resolve(res.Data)
              })
            })
            const csvData = this.makeCsv(searched_data);
            this.setState({
              csvData : csvData
            }, () => {
              this.csvDownloader.current.handleClick()
              this.handleClickNegative();
            })
          }}>OK</Button>
        </div>
        <Row>
          <CsvDownloader
            noHeader={true}
            filename={`invoice_${moment().format("YYYYMMDD_HHmmss")}`}
            datas={this.state.csvData}
            separator=","
            ref={this.csvDownloader}
          >
            <div></div>
          </CsvDownloader>
        </Row>
      </>
    );
  }
}

export class DialogInvoiceCsvDownloadApportionment extends DialogBase {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      csvData : [[]],
      dialogData : {
        values : {},
        errors : {},
        requiredData : {}
      }
    });

    this.csvDownloader = React.createRef();
    this.validateCallback = this.validateCallback.bind(this)
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dialogTitle !== this.props.dialogTitle || prevState.modal !== this.state.modal){
      this.setState({
        title: '一覧CSV出力（売上按分）をします。よろしいですか？',
      });
    }
  }

  validate(){
    let message = getErrorCodes(this.state.dialogData.errors)
    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      dialogData:{
        ...this.state.dialogData,
        ...newData
      }
    }, ()=>callback())
  }

  makeCsv(invoices){
    const csvData = invoices.reduce((acc, data) => {

      acc.push([
        this.isNullOrUndefined(data.estimate_natural_id) ? "" : data.estimate_natural_id,
        this.isNullOrUndefined(data.due_day_rule) ? "" : FormatCode.decode("cst_due_day_rule", data.due_day_rule),
        this.isNullOrUndefined(data.due_day) ? "" : data.due_day,
        this.isNullOrUndefined(data.invoice_process_status) ? "" : FormatCode.decode("cst_invoice_process_status", data.invoice_process_status),
        this.isNullOrUndefined(data.invoice_payment_finish_date) ? "" : moment(data.invoice_payment_finish_date).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.invoice_process_pdf_date) ? "" : moment(data.invoice_process_pdf_date).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.invoice_closing_date) ? "" : moment(data.invoice_closing_date).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.payment_deadline) ? "" : moment(data.payment_deadline).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.accounting_month) ? "" : data.accounting_month,
        this.isNullOrUndefined(data.quote_available_start_date) ? "" : moment(data.quote_available_start_date).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.quote_available_end_date) ? "" : moment(data.quote_available_end_date).format("YYYY/MM/DD"),
        this.isNullOrUndefined(data.invoice_amt) ? 0 : data.invoice_amt,
        this.isNullOrUndefined(data.survey_tax_in_flag) ? '税別' : (data.survey_tax_in_flag == 0 ? '税別' : '税込み'), // 確定見積：税込・税抜区分
        this.isNullOrUndefined(data.quote_subtotal_amt) ? 0 : data.quote_subtotal_amt, // 確定見積：課税金額
        this.isNullOrUndefined(data.quote_tax_amt) ? 0 : data.quote_tax_amt, // 確定見積：税額（税抜きの場合）
        this.isNullOrUndefined(data.estimate_detail_amt_ex) ? 0 : data.estimate_detail_amt_ex, // 確定見積：非課税金額
        this.isNullOrUndefined(data.amount_of_sales) ? "" : data.amount_of_sales,
        this.isNullOrUndefined(data.invoice_customer_name) ? "" : data.invoice_customer_name,
        this.isNullOrUndefined(data.invoice_customer_branch_name) ? "" : data.invoice_customer_branch_name,
        this.isNullOrUndefined(data.invoice_customer_user_name) ? "" : data.invoice_customer_user_name,
        this.isNullOrUndefined(data.construction_number) ? "" : data.construction_number,
        this.isNullOrUndefined(data.site_name) ? "" : data.site_name,
        this.isNullOrUndefined(data.invoice_memo) ? "" : data.invoice_memo,
        this.isNullOrUndefined(data.invoice_user_memo) ? "" : data.invoice_user_memo,
        this.isNullOrUndefined(data.payment_user_memo) ? "" : data.payment_user_memo,
        this.isNullOrUndefined(data.invoice_note) ? "" : data.invoice_note
      ])
      return acc
    }, [[...INVOICE_CSV_APPORTIPONMENT.HEADER]])

    return this.wrappingQuote(csvData);
  }

  isNullOrUndefined(data){
    if(data === undefined || data === null){
      return true;
    }
    return false;
  }

  wrappingQuote = (dataArray) => {
    return dataArray.map(data => 
      data.map((data => {
        if(data===""){
          return data
        } else {
          return '"'+data+'"'
      }})
    ))
  }

  bodyContent() {
    return (
      <>
        <div className="modal-box">
          <Button color="secondary" onClick={this.handleClickNegative}>キャンセル</Button>
          <Button color="info" onClick={async ()=> {
            if(!this.validate()){
              return;
            }

            const search_params = {
              ...this.props.search_params(),
              isCsv : true
            }
            const searched_data = await new Promise((resolve, reject)=> {
              Request.get(`/api/invoice`, search_params , res => {
                let tmp = []
                // console.log(res.Data)
                res.Data.forEach(r=>{
                  var day1 = new Date(r.quote_available_start_date);
                  var day2 = new Date(r.quote_available_end_date);
                   
                  //差日を求める（86,400,000ミリ秒＝１日）
                  var termDay = (day2 - day1) / 86400000;
                  var termMonth = Math.ceil(termDay / 30);
                  let r_tmp = {};
                  for(let i=0;i<termMonth;i++){
                    var day0 = new Date(r.quote_available_start_date);
                    let amount_of_sales = ""
                    let accounting_month = ""

                    day0.setMonth(day1.getMonth() + i);

                    if (day1.getDate() > day1.getDate()) {
                      day0.setDate(0);
                    }
                    console.log(day0,day1,day1.getMonth(),i)
                    accounting_month = moment(day0).format("YYYY年MM月")
                    if(String(i) == String("0") && String(termMonth) != String("1")){
                      amount_of_sales = Math.floor(r.invoice_amt / termMonth) +  r.invoice_amt % termMonth;
                    }else{
                      amount_of_sales = Math.floor(r.invoice_amt / termMonth)
                    }
                    r_tmp = {...r,accounting_month,amount_of_sales}
                    tmp.push(r_tmp)
                  } 
                })
                // console.log(tmp)

                resolve(tmp)
              })
            })
            const csvData = this.makeCsv(searched_data);
            this.setState({
              csvData : csvData
            }, () => {
              this.csvDownloader.current.handleClick()
              this.handleClickNegative();
            })
          }}>OK</Button>
        </div>
        <Row>
          <CsvDownloader
            noHeader={true}
            filename={`invoice_${moment().format("YYYYMMDD_HHmmss")}`}
            datas={this.state.csvData}
            separator=","
            ref={this.csvDownloader}
          >
            <div></div>
          </CsvDownloader>
        </Row>
      </>
    );
  }
}

export class DialogInvoiceCustomer extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      data: {
        values:this.props.data,
        errors:{},
        requiredData:{}
      }
    });

    this.validateCallback = this.validateCallback.bind(this)
  }

  componentDidUpdate(prevProps){
    if (prevProps.data !== this.props.data){

      const change_invoice_flag = this.props.data.values.change_invoice_flag
      const is_empty_change_invoice_name = (
        this.props.data.values.change_invoice_name === null 
        || this.props.data.values.change_invoice_name === undefined
        || this.props.data.values.change_invoice_name === "") ? true : false;

        this.setState({
          title: `請求先を変更する場合は、以下を設定してください。`,
          data: {
            ...this.props.data,
            values : {
              ...this.props.data.values
            },
            errors:{ ...(change_invoice_flag == 1 && is_empty_change_invoice_name ? {change_invoice_name : [GetMessage(2024)]} : undefined) },
            requiredData:{change_invoice_name : [GetMessage(2024)] },
          },
          inProcess : false
        }
      )
    }
  }

  validateCallback(newData, callback=()=>{}){

    console.log(newData);
    const change_invoice_flag = newData.values.change_invoice_flag
    const is_empty_change_invoice_name = 
      (newData.values.change_invoice_name === null 
      || newData.values.change_invoice_name === undefined
      || newData.values.change_invoice_name === "") ? true : false;
    this.setState({
      data:{
        ...this.state.data,
        ...newData,
        values: {
          ...newData.values,
          change_invoice_name : change_invoice_flag == 1 ? newData.values.change_invoice_name : null
        },
        errors:{ 
          ...(change_invoice_flag == 1 ? newData.errors : undefined),
          ...(change_invoice_flag == 1 && is_empty_change_invoice_name ? {change_invoice_name : [GetMessage(2024)]} : undefined) 
        },
        requiredData : { ...(change_invoice_flag == 1 ? {change_invoice_name : [GetMessage(2024)]} : undefined) },
      }
    }, ()=>callback())
  }

  validate(){
    let message = getErrorCodes(this.state.data.errors)

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  handleClickPositive() {
    if(this.state.inProcess){
      return;
    }

    if (!this.validate()){
      return;
    }

    const {
      change_invoice_flag,
      change_invoice_name,
      estimate_update_timestamp,
      estimate_ulid
    } = this.state.data.values;

    const updateParams = {
      change_invoice_flag,
      change_invoice_name,
      update_timestamp : estimate_update_timestamp
    }
    console.log("this.state.data.values ", this.state.data.values)

    Request.put(`/api/quote/${estimate_ulid}`, updateParams, 
      (res)=>{
        this.setState({
          inProcess : true
        })
        this.props.refreshCallback()
        this.handleClickNegative();
    })
  }

  bodyContent(){
    const { change_invoice_flag } = this.state.data.values;

    return(
    <>
      <Row style={{marginBottom: "0.5rem"}}>
        <Col md="3">
          請求先情報
        </Col>
        <Col md="8">
        <InputRadio
          options={cst_invoice_change_flag}
          name='ESTIMATE__change_invoice_flag'
          validateCallback={this.validateCallback} 
          validateType='regist'
          rootData={this.state.data}
        />
      </Col>
      </Row>

      <Row style={{marginBottom: "0.5rem"}}>
        <Col md="3">
          請求先名
        </Col>
        <Col md="8">
          <InputText 
            name='ESTIMATE__change_invoice_name'
            validateCallback={this.validateCallback} 
            validateType='regist'
            rootData={this.state.data}
            disabled={change_invoice_flag == 0}
          />
        </Col>
      </Row>
    </>);
  }
}

export class DialogInvoiceCustomerMainBranch extends DialogBase{
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title:"請求先の支店を選択してください。",
      positive_label:"選択",
      negative: false,
      newtral: true,
      customer_branch:{
        values:{
          customer_name:""
        },
        errors:{},
        requiredData:{}
      },
      customer_branch_list:[],
      customer_branch_select_data:{
        values:{},
        errors:{},
        requiredData:{}
      },
      bankCheck:true,
      addrCheck:true,
      userCheck:true,
      apiUrl:'/api/customer/branch/setting',
      disablePositive : true
    });
    this.validateCallback = this.validateCallback.bind(this)
  }

  componentDidUpdate(prevProps){
    if (prevProps.data !== this.props.data){
      
      let {
        customer_id
      } = this.props.data.values;
      Request.get(this.state.apiUrl, {"customer_id":customer_id}, (res)=>{
        this.setState({
          ...this.state,
          customer_branch: this.props.data,
          customer_branch_list : res.data
        });   
      });
    }
  }

  validateCallback(newData, callback=()=>{}){

    let select_branch_data = this.state.customer_branch_list.find(branch=>branch.customer_branch_natural_id == newData.values.invoice_list_main_branch)

    console.log(select_branch_data, newData);


    let bankCheck = (
      select_branch_data
      && (!select_branch_data.invoice_bank_branch_name 
      || !select_branch_data.invoice_bank_account_kana 
      || !select_branch_data.invoice_bank_account_type 
      || !select_branch_data.invoice_bank_account_number) 
    )? false : true;
    let addrCheck = (
      select_branch_data
      && (!select_branch_data.customer_branch_invoice_prefecture
      || !select_branch_data.customer_branch_invoice_city
      || !select_branch_data.customer_branch_invoice_address
      || !select_branch_data.customer_branch_invoice_zip_code) 
    )? false : true;

    let userCheck = (
      select_branch_data
      && (!select_branch_data.invoice_customer_user_id) 
    )? false : true;
    // console.log(userCheck,select_branch_data,select_branch_data.invoice_customer_user_id)
    let disablePositive = (select_branch_data == undefined || !addrCheck || !bankCheck) ? true : false;

    this.setState({
      addrCheck: addrCheck,
      bankCheck: bankCheck,
      userCheck: userCheck,
      disablePositive: disablePositive,
      customer_branch_select_data:{
        ...this.state.customer_branch_select_data,
        values:{...newData.values}
      }
    });
  }

  validate(){
    let message = getErrorCodes(this.state.data.errors)

    if(message.length > 0){
      this.props.alertModal.current.showErrorModal({messageNo:message});
      return false;
    }
    return true;
  }

  handleClickPositive() {
    // console.log(this.state.customer_branch_select_data);
    let {
      bankCheck,
      addrCheck,
      userCheck,
      apiUrl,
      customer_branch_select_data:{
        values:{invoice_list_main_branch:customer_branch_natural_id}
      }
    } = this.state;

    // console.log(customer_branch_natural_id);
    if (customer_branch_natural_id == null || customer_branch_natural_id == undefined || customer_branch_natural_id.length  == 0 ){
      customer_branch_natural_id = null
    }
    if ( bankCheck && addrCheck && userCheck &&  customer_branch_natural_id != null) {
      Request.put(apiUrl+"/"+String(customer_branch_natural_id),{"customer_branch_natural_id":customer_branch_natural_id},(res)=>{
        console.log(res.data);
        this.setState({
          ...this.state,
          bankCheck:true,
          addrCheck:true,
          userCheck:true,
          customer_branch_list:[],
          customer_branch_select_data:{
            values:{},
            errors:{},
            requiredData:{}
          },
        },()=>{
          this.props.refreshCallback()
          this.toggleModal();
        });
      });
    }
}

  handleClickNewtral(){
    this.setState({
      ...this.state,
      bankCheck:true,
      addrCheck:true,
      userCheck:true,
      disablePositive:true,
      customer_branch_list:[],
      customer_branch_select_data:{
        values:{},
        errors:{},
        requiredData:{}
      },
    },()=>{
      this.toggleModal();
    });
  }

  handleClickNegative() {
    this.setState({
      ...this.state,
      bankCheck:true,
      addrCheck:true,
      userCheck:true,
      disablePositive:true,
      customer_branch_list:[],
      customer_branch_select_data:{
        values:{},
        errors:{},
        requiredData:{}
      },
    },()=>{
      this.toggleModal();
    });
  }

  bodyContent(){
    var options = [];
    if ( this.state.customer_branch_list.length > 0 ) {
      for ( var n in this.state.customer_branch_list ) {
        let {
          customer_branch_name,
          customer_branch_natural_id,
          invoice_list_create_flag,
          invoice_list_create_type
        }=this.state.customer_branch_list[n];
        if (invoice_list_create_type == "1" && invoice_list_create_flag == "1"){
          options.push({
            value:customer_branch_natural_id,
            label:customer_branch_name
          });
        }
      }
    }

    return(<>
        <Row style={{marginBottom: "0.5rem"}}>
          <Col md="3">
            {this.state.customer_branch.values?this.state.customer_branch.values.customer_name:""}
          </Col>
          <Col md="8">
            <InputSelect
                isSearchable={true}
                label="請求先の支店"
                labelOn={false}
                name="INVOICE__invoice_list_main_branch"
                options={options}
                validateCallback={this.validateCallback} 
//                  validateType='search'
                rootData={this.state.customer_branch_select_data}
              />
              {!this.state.addrCheck && (<><div style={{color:"red"}}>この支店には請求先情報が登録されていません</div></>)}
              {!this.state.bankCheck && (<><div style={{color:"red"}}>この支店には口座情報が登録されていません</div></>)}
              {!this.state.userCheck && (<><div style={{color:"red"}}>この支店には請求担当が登録されていません</div></>)}
          </Col>
        </Row>
      </>);
  }
}

export class DialogContract extends DialogBase{
	constructor(props) {
		super(props);
		const now = new Date();
		const buf = moment(now);

		Object.assign(this.state, {
		  title: '契約書作成',
		  data:{
			...this.props.data,
			values:{
			  ...this.props.data.values,
			},
			errors:{}
		  },
		  cuEstimate :{
			values:{},
			errors:{},
			requiredData:{},
			check:false,  
		  },
		});
		// console.log(this.props.data)
		
	  }
	
    async componentDidUpdate(prevProps, prevState){
      if(prevProps.data!=this.props.data){
        this.setState({
        data:this.props.data
        })
      }
    }
	

	  handleClickNegative(){
	  	//いいえを押した場合、入力値初期化
  		this.toggleModal();
	  }

	  async handleClickPositive(){

		const {
			estimate_id,
			customer_natural_id,
			customer_branch_natural_id,
			customer_user_natural_id,
			subcontract_customer_branch_natural_id,
			subcontract_customer_user_natural_id,
			request_natural_id,
			project_natural_id,
			invoice_natural_id,
			invoice_process_pdf_date,
			estimate_natural_id,
			quote_available_start_date,
			quote_available_end_date,
			request_type,
			// invoice_closing_date,
			invoice_amt,
			contract_create_flag,
			change_invoice_flag,
			change_invoice_name,
			contract_format_url,
			survey_capacity_flag_car,
			survey_capacity_flag_light_truck,
			quote_plotting_number,
			quote_capacity_qty,
			survey_parking_picture_url,
			survey_route_picture_url,
			survey_route_zoom_picture_url,
			quote_plotting_picture_url,
			survey_parking_address_contract,
			survey_site_distance_meter,
			survey_site_distance_minute,
			latest_pdf_plotting_url: original_latest_pdf_plotting_url,
			user_branch_natural_id,
			parking_latitude,
			parking_longitude,
			project_latitude,
			project_longitude,
			want_guide_type,
			want_guide_type_subcontract,			
			latest_plotting_picture_url,
			latest_pdf_plotting_request_status,
			payment_due_rule_month,
			payment_due_rule_day,
			survey_route_zoom_qr_url,
			payment_deadline:tmp_payment_deadline,
      estimate_update_timestamp,
      estimate_payment_deadline,
		} = this.state.data.values
		console.log(this.state.data.values)

		try{
				
			const estimateCommonParams = await Request.getEstimateCommon({
				customer_branch_natural_id,
				customer_user_natural_id,
				project_natural_id,
				request_natural_id,
				subcontract_customer_branch_natural_id,
				subcontract_customer_user_natural_id,
				estimateObject: this.state.data.values,
				user_branch_natural_id
			})

      const { 
        invoice_closing_date, 
        invoice_process_pdf_date, 
        payment_deadline 
      } = this.calcPaymentDeadline(payment_due_rule_month, payment_due_rule_day,estimate_payment_deadline );

			let origin_invoice_closing_date = invoice_closing_date ? invoice_closing_date : moment().format("YYYY-MM-DD") 

			Request.setProgress(20)
			let routeData;
			let estimateData = {
				...this.state.data.values,
				quote_route_picture_url: null,
				ESTIMATE__quote_route_picture_url: null,
				quote_route_zoom_picture_url: null,
				ESTIMATE__quote_route_zoom_picture_url: null,
			} ;

      let G05_PDF = {};
      //契約書送付有無が有りのもの
      if(contract_create_flag == "1"){
        //契約共通パラメータ取得
        const contractCommon = await Request.getContractCommon({
          customer_branch_natural_id,
          customer_user_natural_id,
          subcontract_customer_branch_natural_id,
          subcontract_customer_user_natural_id,
          request_natural_id,
          project_natural_id,
          invoice_natural_id,
          invoice_process_pdf_date,
          estimate_natural_id,
          quote_available_start_date,
          quote_available_end_date,
          request_type,
          payment_deadline,
          invoice_closing_date,
          invoice_amt,
        })

        const estimate_detail_data = await new Promise((resolve, reject)=>{
          // 確定見積詳細取得API呼び出し
          Request.get(`/api/estimate/detail/quote/${estimate_natural_id}`, {}, res=>{
            if (!res.Data[0]){
              resolve({
                estimate_natural_id : estimate_natural_id,
                Code : 805,
              })
            }
            resolve(res.Data)
          }, err => {
            resolve({
              estimate_natural_id : estimate_natural_id,
              Code : 805,
            })
          })
        })
        

        if(estimate_detail_data.Code >= 800){
          return {
            estimate_natural_id : estimate_natural_id,
            Code : 805,
          }
        }

        //課税非課税追加項目対応 
        const quote_subtotal_amt = contractCommon.object_estimate.ESTIMATE__quote_subtotal_amt;

        const other_nontax_detail_name = estimate_detail_data.find(item => item.estimate_detail_add_flag == "1" && item.non_taxable_flag == "1")?.estimate_detail_name || "";
        const other_nontax_detail_amt = estimate_detail_data.find(item => item.estimate_detail_add_flag == "1" && item.non_taxable_flag == "1")?.estimate_detail_amt || "";
        const estimate_detail_amt_ex = estimate_detail_data.find(item => item.estimate_detail_add_flag == "1" && item.non_taxable_flag == "1")?.estimate_detail_amt || 0;
        const other_tax_total_amt = quote_subtotal_amt - (estimate_detail_amt_ex ? estimate_detail_amt_ex : 0);
        const other_tax_detail_name = estimate_detail_data.find(item => item.estimate_detail_add_flag == "1" && item.non_taxable_flag == "0")?.estimate_detail_name || "";
        const other_tax_detail_amt = estimate_detail_data.find(item => item.estimate_detail_add_flag == "1" && item.non_taxable_flag == "0")?.estimate_detail_amt || "";

        let add_other_data = {ESTIMATE_DETAIL__other_nontax_detail_name:other_nontax_detail_name,
                              ESTIMATE_DETAIL__other_nontax_detail_amt:other_nontax_detail_amt,
                              ESTIMATE__other_nontax_total_amt:other_nontax_detail_amt,
                              ESTIMATE__other_tax_total_amt:other_tax_total_amt,
                              ESTIMATE_DETAIL__other_tax_detail_name:other_tax_detail_name,
                              ESTIMATE_DETAIL__other_tax_detail_amt:other_tax_detail_amt};

        // 独自契約書
        let customContract = CustomReport.contract.find(item => {
          return item.customer_natural_id === customer_natural_id 
          && item.customer_branch_natural_id === customer_branch_natural_id
        })
    
        customContract = customContract || CustomReport.contract.find(item => {
          return item.customer_natural_id === customer_natural_id 
        })
        // console.log("customContract ", customContract)
        // console.log(contractCommon);
        let mergeContractCommon = {
          ...contractCommon,
          object_estimate:{
            ...contractCommon.object_estimate,
            ESTIMATE__survey_parking_rent: contractCommon.object_estimate.ESTIMATE__survey_parking_rent,
            ESTIMATE__quote_subtotal_amt: quote_subtotal_amt
          },
          object_invoice:{
            ...contractCommon.object_invoice,
            INVOICE__invoice_natural_id: invoice_natural_id,
            INVOICE__invoice_closing_date: origin_invoice_closing_date,
            INVOICE__invoice_amt: invoice_amt,
            INVOICE__payment_deadline: payment_deadline,
          },
          object_each_data:{
            ...add_other_data
          },
        }
        // G05_PDF_契約書
        G05_PDF = await new Promise((resolve, reject)=>{
          Request.post( `/api/pout/${customContract ? customContract.format : "G05_PDF"}`, {
          ...mergeContractCommon,
          format_url:GoogleDrive.getFormatUrl((contract_format_url
            ?contract_format_url
            :customContract ? format_url[customContract.format] :format_url.G05_PDF)),
          }, res=>{
          Request.setProgress(70)
          resolve(res)
          }, err => {
          resolve({
            estimate_natural_id : estimate_natural_id,
            Code : 805,
          })
          })
        })
        if(G05_PDF.Code >= 800){
          return G05_PDF;
        }
      }
      let contract_pdf_url = G05_PDF.Data ? G05_PDF.Data.spreadsheet_id : null;
		
			Request.setProgress(60)
			
			const params = {
			...this.state.data.values,
			contract_pdf_url,			
			login_user: localStorage.getItem("name"),
      contract_create_update:1,
			}
			const resultCode = await new Promise((resolve, reject)=>{
        Request.put('/api/invoice/file_upload/' + this.state.data.values.invoice_ulid, params, async res=>{
          Request.setProgress(0)
          this.props.refreshCallback();
          this.toggleModal();
        },(err)=>{
          Request.setProgress(0)
        })
			})
			
			Request.setProgress(90)
			if (resultCode == 200){
		
				Request.setProgress(0)
				document.body.style.overflow = "auto";

				this.props.alertModal.current.confirmCheck({
					title: "処理完了",
					messageNo: [2417],
					closeBtn: false
				}, ()=>{
					this.props.refreshCallback()
					this.toggleModal();
				}, false)
			}
			Request.setProgress(0)
		}catch(err){
			console.log(err);
			Request.setProgress(0)
			this.props.alertModal.current.showErrorModal({
			  messageNo: 2476
			})
		}
  }

  // 20250902追加
  calcPaymentDeadline = (payment_due_rule_month, payment_due_rule_day, estimate_payment_deadline) => {
    const { invoice_closing_date } = this.props;

    // 請求書PDF生成日
    const invoice_process_pdf_date = moment().format("YYYY-MM-DDT00:00:00")
    // 支払期限日計算
    let payment_deadline = ""
    console.log(estimate_payment_deadline)

    if(estimate_payment_deadline !== "" && estimate_payment_deadline !== null){
      payment_deadline = moment(estimate_payment_deadline);
      payment_deadline = payment_deadline.format("YYYY-MM-DDT00:00:00")

    }else{
      payment_deadline = moment(invoice_closing_date);
      // 支払期限日ルール：月
      payment_deadline.add(payment_due_rule_month, 'months');
      // 支払期限日ルール：日が「月末」の場合、当月の最終日を設定する
      if(payment_due_rule_day == 0){
        const endOfMonth = payment_deadline.endOf('month').format('DD');
        payment_deadline.date(endOfMonth);
      } else {
        payment_deadline.date(payment_due_rule_day);
      }

      payment_deadline = payment_deadline.format("YYYY-MM-DDT00:00:00")

    }
    console.log(payment_deadline)
    

    return {
      invoice_closing_date,
      invoice_process_pdf_date,
      payment_deadline
    }
  }

	  bodyContent() {
	//    console.log('dialog state', this.state)
		const {
			change_invoice_flag,
			} = this.state.data.values
		
		// console.log(this.state.data.values);
		return (
		  <>
      契約書を作成します。よろしいですか？
			</>
		);
	  }
}  

export default List;